// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/500.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/profile-back.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  font-size: 14px;
  width: 100%;
  height: 100%;
  min-height: 100vh;
}

html {
  overflow-x: hidden;
}

body {
  background-color: #181821 !important;
  font-weight: 400;
  color: #9a9cab !important;
  line-height: 1.6;
}

a {
  color: #83d8ae;
  text-decoration: none;
}

a:hover {
  color: #e8538f !important;
}

p {
  line-height: 1.6;
}

small {
  font-size: 80%;
  font-weight: 400;
}

menu {
  padding-left: 0;
}

a,
body,
span,
text {
  font-family: Poppins, sans-serif;
}

a:active,
a:focus,
a:hover {
  outline: 0 !important;
  text-decoration: none !important;
}

.bold,
b,
strong {
  font-weight: 600;
}

dt {
  font-weight: 500;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: Poppins, sans-serif;
}

.divider {
  display: block;
  content: "";
  width: 100%;
  height: 1px;
  background: #e8e8e8;
  margin: 30px 0;
}

.no-s {
  margin: 0 !important;
  padding: 0 !important;
}

.no-m {
  margin: 0;
}

.no-p {
  padding: 0;
}

.m {
  margin: 15px;
}

.m-t-xxs {
  margin-top: 5px;
}

.m-r-xxs {
  margin-right: 5px;
}

.m-b-xxs {
  margin-bottom: 5px;
}

.m-l-xxs {
  margin-left: 5px;
}

.m-t-xs {
  margin-top: 10px;
}

.m-r-xs {
  margin-right: 10px;
}

.m-b-xs {
  margin-bottom: 10px;
}

.m-l-xs {
  margin-left: 10px;
}

.m-t-sm {
  margin-top: 15px;
}

.m-r-sm {
  margin-right: 15px;
}

.m-b-sm {
  margin-bottom: 15px;
}

.m-l-sm {
  margin-left: 15px;
}

.m-t-md {
  margin-top: 20px;
}

.m-r-md {
  margin-right: 20px;
}

.m-b-md {
  margin-bottom: 20px;
}

.m-l-md {
  margin-left: 20px;
}

.m-t-lg {
  margin-top: 25px;
}

.m-r-lg {
  margin-right: 25px;
}

.m-b-lg {
  margin-bottom: 25px;
}

.m-l-lg {
  margin-left: 25px;
}

.m-t-xxl {
  margin-top: 30px;
}

.m-r-xxl {
  margin-right: 30px;
}

.m-b-xxl {
  margin-bottom: 30px;
}

.m-l-xxl {
  margin-left: 30px;
}

.m-t-n-xxs {
  margin-top: -5px;
}

.m-r-n-xxs {
  margin-right: -5px;
}

.m-b-n-xxs {
  margin-bottom: -5px;
}

.m-l-n-xxs {
  margin-left: -5px;
}

.m-t-n-xs {
  margin-top: -10px;
}

.m-r-n-xs {
  margin-right: -10px;
}

.m-b-n-xs {
  margin-bottom: -10px;
}

.m-l-n-xs {
  margin-left: -10px;
}

.m-t-n-sm {
  margin-top: -15px;
}

.m-r-n-sm {
  margin-right: -15px;
}

.m-b-n-sm {
  margin-bottom: -15px;
}

.m-l-n-sm {
  margin-left: -15px;
}

.m-t-n-md {
  margin-top: -20px;
}

.m-r-n-md {
  margin-right: -20px;
}

.m-b-n-md {
  margin-bottom: -20px;
}

.m-l-n-md {
  margin-left: -20px;
}

.m-t-n-lg {
  margin-top: -25px;
}

.m-r-n-lg {
  margin-right: -25px;
}

.m-b-n-lg {
  margin-bottom: -25px;
}

.m-l-n-lg {
  margin-left: -25px;
}

.m-t-n-xxl {
  margin-top: -30px;
}

.m-r-n-xxl {
  margin-right: -30px;
}

.m-b-n-xxl {
  margin-bottom: -30px;
}

.m-l-n-xxl {
  margin-left: -30px;
}

.p {
  padding: 15px;
}

.p-h-xxs {
  padding-left: 5px;
  padding-right: 5px;
}

.p-h-xs {
  padding-left: 10px;
  padding-right: 10px;
}

.p-h-sm {
  padding-left: 15px;
  padding-right: 15px;
}

.no-p-h {
  padding-left: 0;
  padding-right: 0;
}

.no-p-v {
  padding-top: 0;
  padding-bottom: 0;
}

.p-h-md {
  padding-left: 20px;
  padding-right: 20px;
}

.p-h-lg {
  padding-left: 25px;
  padding-right: 25px;
}

.p-h-xxl {
  padding-left: 30px;
  padding-right: 30px;
}

.p-v-xxs {
  padding-top: 5px;
  padding-bottom: 5px;
}

.p-v-xs {
  padding-top: 10px;
  padding-bottom: 10px;
}

.p-v-sm {
  padding-top: 15px;
  padding-bottom: 15px;
}

.p-v-md {
  padding-top: 20px;
  padding-bottom: 20px;
}

.p-v-lg {
  padding-top: 25px;
  padding-bottom: 25px;
}

.p-v-xxl {
  padding-top: 30px;
  padding-bottom: 30px;
}

.full-height {
  height: 100% !important;
}

.full-width {
  width: 100% !important;
}

.w-xxs {
  width: 50px;
}

.w-xs {
  width: 90px;
}

.w-sm {
  width: 140px;
}

.w {
  width: 200px;
}

.w-md {
  width: 240px;
}

.w-lg {
  width: 280px;
}

.w-xl {
  width: 330px;
}

.w-xxl {
  width: 370px;
}

.w-auto {
  width: auto;
}

.h-auto {
  height: auto;
}

.no-b {
  border: 0 !important;
}

.b {
  border: 1px solid #eaecf3;
}

.b-t {
  border-top: 1px solid #eaecf3;
}

.b-r {
  border-right: 1px solid #eaecf3;
}

.b-b {
  border-bottom: 1px solid #eaecf3;
}

.b-l {
  border-left: 1px solid #eaecf3;
}

.b-default {
  border-color: #eaecf3;
}

.b-primary {
  border-color: #83d8ae;
}

.b-info {
  border-color: #9c6efc;
}

.b-success {
  border-color: #83d8ae;
}

.b-warning {
  border-color: #ffaf0f;
}

.b-danger {
  border-color: #ee6e83;
}

.b-2 {
  border-width: 2px;
}

.b-3 {
  border-width: 3px;
}

.b-4 {
  border-width: 4px;
}

.b-n-t {
  border-top: 0;
}

.b-n-r {
  border-right: 0;
}

.b-n-b {
  border-bottom: 0;
}

.b-n-l {
  border-left: 0;
}

.no-r {
  border-radius: 0 !important;
}

.r {
  border-radius: 15px;
}

.r-t-l {
  border-top-left-radius: 15px;
}

.r-t-r {
  border-top-right-radius: 15px;
}

.r-b-l {
  border-bottom-left-radius: 15px;
}

.r-b-r {
  border-bottom-right-radius: 15px;
}

.no-r-t-l {
  border-top-left-radius: 0 !important;
}

.no-r-t-r {
  border-top-right-radius: 0 !important;
}

.no-r-b-l {
  border-bottom-left-radius: 0 !important;
}

.no-r-b-r {
  border-bottom-right-radius: 0 !important;
}

.bg-primary {
  background-color: #86c1ed !important;
}

.bg-secondary {
  background-color: #e9f0f2 !important;
}

.bg-success {
  background-color: #83d8ae !important;
}

.bg-danger {
  background-color: #e8538f !important;
}

.bg-warning {
  background-color: #fad292 !important;
}

.bg-info {
  background-color: #ada6f2 !important;
}

.bg-light {
  background-color: #f3f6f9 !important;
}

.bg-dark {
  background-color: #242e44 !important;
}

.text-muted {
  color: #7d7f8c !important;
}

.text-white {
  color: #fff;
}

.text-primary {
  color: #86c1ed !important;
}

.text-secondary {
  color: #5b6875 !important;
}

.text-success {
  color: #83d8ae !important;
}

.text-danger {
  color: #e8538f !important;
}

.text-warning {
  color: #fad292 !important;
}

.text-info {
  color: #ada6f2 !important;
}

.text-light {
  color: #f3f6f9 !important;
}

.text-dark {
  color: #5b5b5b !important;
}

.page-container {
  position: relative;
  display: block;
}

.page-header {
  position: absolute;
  width: calc(100% - 280px);
  margin: 0 30px;
  top: 0;
  right: 0;
  z-index: 999;
  transition: all 0.2s ease-in-out;
}

.header-title h5 {
  margin: 0;
  line-height: 41px;
  color: #fff;
}

.header-search {
  background-color: #181821;
  border-radius: 10px;
}

.header-search:before {
  display: block;
  content: "search";
  font-family: "Material Icons";
  font-size: 20px;
  height: 42px;
  line-height: 42px;
  padding: 0 15px;
  position: absolute;
  z-index: 99;
  color: #9a9cab;
}

.header-search .form-control {
  margin-left: 30px;
  border: none;
  background-color: #181821;
  width: calc(100% - 30px);
  color: #fff;
}

.header-search .form-control::placeholder {
  color: #9a9cab;
}

.header-search .form-control:focus {
  outline: 0;
  box-shadow: none;
}

.header-search .close-search {
  display: none;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #9a9cab;
}

.header-search .close-search svg {
  width: 20px;
  height: 20px;
}

.page-header .navbar {
  padding: 14px 30px;
  display: flex !important;
  border-bottom: 1px solid #262635;
}

.page-header .navbar .logo {
  display: flex !important;
  flex: 2 1;
}

.page-header .navbar #activity-sidebar-toggle {
  background: #1f1f2b;
  line-height: 22px;
  border-radius: 5px;
  min-width: 40px;
  text-align: center;
  font-weight: 700;
  box-shadow: 0 1px 3px 0 rgb(54 74 99 / 5%);
}

.page-header .navbar #activity-sidebar-toggle svg {
  color: #fff;
  width: 18px !important;
  height: 18px !important;
}

.page-header .navbar a#sidebar-toggle {
  padding: 9px 0;
  margin-right: 20px;
  float: left;
  transform: rotate(0);
  display: none;
  transition: all 0.2s ease-in-out;
}

.page-header .navbar a#sidebar-toggle:hover {
  background: 0 0;
}

.page-header .navbar #headerNav,
.page-header .navbar #navbarNav {
  display: flex !important;
  flex: 10 1;
}

.page-header .navbar #headerNav .navbar-nav,
.page-header .navbar #navbarNav .navbar-nav {
  flex-direction: row !important;
}

.page-header #sidebar-toggle svg {
  color: #9a9cab;
  width: 22px;
  height: 22px;
}

.page-header .navbar #headerNav > ul > li > a {
  padding: 9px 0;
  margin: 0 7px;
  color: #9a9cab;
  transition: all 0.2s ease-in-out;
}

.page-header .navbar #headerNav > ul > li > a svg {
  line-height: 22px;
  vertical-align: middle;
  width: 21px;
  height: 21px;
}

.page-header .navbar #headerNav > ul > li > a.notifications-dropdown {
  padding: 9px 15px;
  background: #1f1f2b;
  color: #fff;
  line-height: 22px;
  border-radius: 5px;
  min-width: 40px;
  text-align: center;
  font-weight: 700;
  box-shadow: 0 1px 3px 0 rgb(54 74 99 / 5%);
}

.page-header
  .navbar
  #headerNav
  > ul
  > li
  > a.notifications-dropdown
  .spinner-grow {
  width: 8px;
  height: 8px;
  right: 16px;
  top: 9px;
  position: absolute;
  animation: 2.4s linear infinite spinner-grow;
}

.page-header .navbar #headerNav > ul > li > a.profile-dropdown {
  padding: 0;
  margin-right: 0;
}

.page-header .navbar #headerNav > ul > li > a img {
  width: 40px;
  box-shadow: 0 1px 3px 0 rgb(54 74 99 / 5%);
  border-radius: 5px;
}

.page-header .navbar .navbar-nav {
  flex: 10 1;
  padding: 0;
}

.navbar-nav .activity-trigger svg {
  color: #9a9cab;
}

.page-header #headerNav {
  flex: 10 1;
  align-items: flex-end;
  flex-direction: column;
}

.page-header .header-notif {
  padding: 13px 26px;
  transition: all 0.1s ease-in-out;
}

.page-header .header-notif:hover .notif-text {
  color: #fff;
  transition: all 0.1s ease-in-out;
}

.page-header .header-notif .notif-image {
  float: left;
  margin-right: 10px;
  margin-top: 3px;
  border-radius: 50%;
}

.page-header .header-notif .notif-image span {
  width: 40px;
  height: 40px;
  display: block;
  line-height: 40px;
  text-align: center;
  border-radius: 5px;
  display: inline-block;
}

.page-header .header-notif .notif-image img {
  width: 40px;
  height: 40px;
  border-radius: 5px;
}

.page-header .header-notif .notif-text {
  width: 223px;
  display: block;
  padding: 0 5px;
  display: inline-block;
  color: #9a9cab;
  font-weight: 400;
}

.page-header .header-notif .notif-text .bold-notif-text {
  font-weight: 500;
}

.page-header .header-notif .notif-text p {
  margin: 0;
}

.page-header .header-notif .notif-text small {
  opacity: 0.7;
}

.profile-drop-menu a span {
  margin-left: 25px;
}

.search-drop-menu {
  width: 340px;
}

.notif-drop-menu {
  width: 340px;
  max-height: 420px;
  overflow-y: auto;
}

.notif-drop-menu .dropdown-header {
  margin-bottom: 5px;
  font-size: 14px;
}

.profile-drop-menu a svg {
  margin-right: 10px;
  width: 19px;
  height: 19px;
}

.navbar-nav .dropdown-menu {
  position: absolute !important;
  visibility: hidden;
  opacity: 0;
  margin-top: 30px;
  display: block;
  transition: all 0.2s ease-in-out;
}

.navbar-nav .dropdown-menu.show {
  margin-top: 20px;
  opacity: 1;
  visibility: visible;
}

.slimScrollBar {
  background: rgba(0, 0, 0, 0.2) !important;
  border-radius: 4px !important;
}

.page-sidebar {
  position: fixed;
  height: 100%;
  z-index: 9999;
  left: 0;
  background: #1f1f2b;
  box-shadow: 0 1px 3px 0 rgb(54 74 99 / 5%);
  top: 0;
  width: 280px;
  transition: all 0.2s ease-in-out;
  transform: scale(1, 1);
  transform-origin: left;
  /* overflow-x: scroll; */
  /* overflow: visible; */
}

.page-sidebar .ps__rail-y {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
  background-color: transparent !important;
}

.page-sidebar .accordion-menu {
  margin-top: 20px;
  height: calc(100% - 141px) !important;
  padding: 10px 15px;
}

.page-sidebar .accordion-menu > li > a {
  display: block;
  color: #9a9cab;
  transition: all 0.1s ease-in-out;
  line-height: 45px;
  padding: 5px;
  text-decoration: none;
}

.page-sidebar .accordion-menu > li.active-page > a {
  color: #83d8ae;
  font-weight: 500;
}

.page-sidebar .accordion-menu > li.active-page > a > svg {
  color: #83d8ae !important;
}

.page-sidebar .accordion-menu > li.active-page ul li a.active {
  color: #fff;
}

.page-sidebar .accordion-menu > li > a:hover svg {
  margin-left: 5px;
}

.page-sidebar .accordion-menu > li > a > svg {
  width: 21px;
  height: 21px;
  line-height: 40px;
  text-align: center;
  vertical-align: text-top;
  color: #9a9cab;
  margin-right: 15px;
  transition: all 0.2s ease-in-out;
}

.page-sidebar .accordion-menu li.sidebar-title {
  font-weight: 500;
  padding: 10px 15px;
  font-size: 0.875rem;
  color: #6c757d;
  opacity: 0.8;
}

.page-sidebar .accordion-menu li a .dropdown-icon {
  float: right;
  vertical-align: middle;
  line-height: 44px;
  font-size: 10px;
  transition: all 0.2s ease-in-out;
}

.page-sidebar .accordion-menu li.open > a > .dropdown-icon {
  visibility: visible;
  transform: rotate(90deg);
}

.page-sidebar .accordion-menu li ul {
  padding: 5px 0;
  list-style: none;
}

.page-sidebar .accordion-menu li ul li a {
  color: #9a9cab;
  display: block;
  padding: 5px 15px;
  font-size: 14px;
  position: relative;
  transition: all 0.15s ease-in-out;
  text-decoration: none;
}

.page-sidebar .accordion-menu li ul li a:hover {
  margin-left: 5px;
}

.page-sidebar .accordion-menu li ul li a i {
  font-size: 10px;
  padding-right: 21px;
  padding-left: 6px;
}

.page-sidebar .logo {
  margin-right: 0;
  width: auto;
  height: 30px;
  margin: 18px auto;
  display: block;
  text-align: center;
  font-size: 30px;
  font-weight: 500;
}

@media (min-width: 1350px) {
  .page-sidebar-collapsed .page-sidebar {
    width: 80px;
    /* overflow: visible !important; */
    overflow-x: scroll !important;
    border-radius: 0;
  }

  .page-sidebar-collapsed .logo {
    font-size: 0;
  }

  .page-sidebar-collapsed .logo::first-letter {
    font-size: 20px;
  }

  .page-sidebar-collapsed .page-content {
    margin-left: 80px;
  }

  .page-sidebar-collapsed .page-header {
    width: calc(100% - 160px);
  }

  .page-sidebar-collapsed .page-sidebar .accordion-menu {
    padding: 0;
    overflow: visible;
    position: absolute !important;
    /* height: auto !important; */
    top: 50%;
    /* top: 50%; */
    transform: translateY(-50%);
    margin-top: 0;
  }

  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a {
    font-size: 0;
  }

  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a {
    text-align: center;
    padding: 8px;
    width: 80px;
  }

  .page-sidebar-collapsed
    .page-sidebar
    .accordion-menu
    > li
    > a
    > .dropdown-icon {
    display: none;
  }

  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a > svg {
    margin: 0;
    vertical-align: middle;
  }

  .page-sidebar-collapsed .page-sidebar .accordion-menu > li {
    position: relative;
  }

  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a + ul {
    display: block !important;
    position: absolute;
    margin-left: 0;
    top: -15px;
    left: 110px;
    padding: 20px 0;
    background: #1f1f2b;
    box-shadow: 0 0 11px 1px rgba(0, 0, 0, 0.05);
    -webkit-box-shadow: 0 0 11px 1px rgba(0, 0, 0, 0.05);
    -moz-box-shadow: 0 0 11px 1px rgba(0, 0, 0, 0.05);
    min-width: 200px;
    opacity: 0;
    visibility: hidden;
    border-radius: 15px;
    transition: all 0.2s ease-in-out;
  }

  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a + ul::after {
    position: absolute;
    top: 40px;
    left: -7px;
    right: auto;
    display: inline-block !important;
    border-right: 7px solid #1f1f2b;
    border-bottom: 7px solid transparent;
    border-top: 7px solid transparent;
    content: "";
  }

  .page-sidebar-collapsed .page-sidebar .accordion-menu > li:hover > ul,
  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a:hover + ul {
    height: auto;
    visibility: visible;
    opacity: 1;
    left: 120px;
  }

  .page-sidebar-collapsed .page-sidebar .accordion-menu > li:hover {
    width: calc(100% + 30px);
  }

  .page-sidebar-collapsed .page-sidebar .accordion-menu > li:hover > a > svg {
    color: #83d8ae;
  }

  #sidebar-collapsed-toggle {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 21px 0;
    text-align: center;
    transform: rotate(0);
    background-color: #1f1f2b;
    transition: all 0.2s ease-in-out;
  }

  #sidebar-collapsed-toggle svg {
    width: 22px;
    height: 22px;
    vertical-align: middle;
    font-size: 22px;
    color: #9a9cab;
  }

  body:not(.page-sidebar-collapsed) #sidebar-collapsed-toggle {
    transform: rotate(180deg);
  }
}

@media (max-width: 1350px) {
  #sidebar-collapsed-toggle {
    display: none;
  }
}

.page-content {
  padding: 70px 70px 0 70px;
  margin-left: 220px;
  transition: all 0.2s ease-in-out;
}

.main-wrapper {
  padding: 30px 10px;
  min-height: calc(100vh - 142px);
  transition: all 0.2s ease-in-out;
}

.page-footer {
  margin: 0 -40px;
  width: calc(100% + 80px);
  border-top: 1px solid #262635;
}

.page-footer a {
  color: #9a9cab;
}

.page-footer a svg {
  width: 22px;
  height: 22px;
}

.footer-left {
  margin-right: 5px;
}

.footer-right {
  margin-left: 5px;
}

.page-footer .page-footer-item {
  padding: 24px 30px;
  width: 50%;
}

.page-footer .page-footer-item.page-footer-item-left {
  float: left;
}

.page-footer .page-footer-item.page-footer-item-right {
  float: right;
  text-align: right;
}

.popover {
  margin: 20px;
  border: 0;
  border-radius: 10px;
  box-shadow: 0 0 1.25rem rgba(31, 45, 61, 0.08);
  color: #5b5b5b;
  font-family: Poppins, sans-serif !important;
}

.popover-header {
  padding: 15px 25px 0;
  background: 0 0;
  border-bottom-color: transparent;
  font-size: 14px;
  opacity: 0.7;
  color: #5b5b5b;
}

.popover-body {
  padding: 15px 25px;
  font-size: 13px;
  color: #5b5b5b;
}

.popover .arrow:before {
  display: none;
}

.bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before,
.bs-popover-bottom > .popover-arrow::before,
.bs-popover-end > .popover-arrow::before,
.bs-popover-start > .popover-arrow::before,
.bs-popover-top > .popover-arrow::before {
  display: none;
}

.card {
  margin-bottom: 21px;
  border-radius: 5px;
  border: none;
  background: #1f1f2b;
}

.card-bg {
  background-color: #1f1f2b;
}

.card-title {
  font-size: 16px;
  color: #fff;
  margin-bottom: 25px;
}

.card-body {
  padding: 25px;
}

.card-description {
  margin-bottom: 20px;
}

.card-img,
.card-img-top {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.card-img,
.card-img-bottom {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.card-footer,
.card-header {
  border-color: #262635;
}

.list-group-item {
  background: 0 0;
}

.list-group-item.disabled,
.list-group-item:disabled {
  background: 0 0;
}

.list-group-item:first-child {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.list-group-item:last-child {
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.list-group-item {
  padding: 15px 18px;
  border-color: #262635;
}

.list-group-item.active {
  background-color: #83d8ae;
  border-color: #83d8ae;
}

.list-group-item-action:focus,
.list-group-item-action:hover {
  background: 0 0;
  color: #fff;
}

.list-group-item.active:focus,
.list-group-item.active:hover {
  background: #83d8ae;
}

.list-group-item-action {
  color: #9a9cab;
}

.list-group-item-primary {
  color: #fff;
  background-color: #86c1ed;
  font-weight: 500;
}

.list-group-item-secondary {
  color: #5b6875;
  background-color: #e9f0f2;
  font-weight: 500;
}

.list-group-item-success {
  color: #fff;
  background-color: #83d8ae;
  font-weight: 500;
}

.list-group-item-danger {
  color: #fff;
  background-color: #e8538f;
  font-weight: 500;
}

.list-group-item-warning {
  color: #fff;
  background-color: #fad292;
  font-weight: 500;
}

.list-group-item-info {
  color: #fff;
  background-color: #ada6f2;
  font-weight: 500;
}

.list-group-item-light {
  color: #7e8299;
  background-color: #f3f6f9;
  font-weight: 500;
}

.list-group-item-dark {
  color: #5b5b5b;
  background-color: #d1d3e0;
  font-weight: 500;
}

.card-header:first-child {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.card-footer:last-child {
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.card-img-overlay {
  border-radius: 5px;
}

.card.bg-primary .card-header {
  background-color: #83d8ae;
  border-color: #83d8ae;
}

.card.bg-primary .card-title {
  color: #fff;
}

.card.bg-secondary .card-header {
  background-color: #e4e6ef;
  color: #5b5b5b;
}

.card.bg-secondary .card-body {
  color: #5b5b5b;
}

.card.bg-success .card-header {
  background-color: #83d8ae;
  border-color: #83d8ae;
}

.card.bg-success .card-title {
  color: #fff;
}

.card.bg-danger .card-header {
  background-color: #e8538f;
  border-color: #e8538f;
}

.card.bg-danger .card-title {
  color: #fff;
}

.card.bg-warning .card-header {
  background-color: #f5af47ea;
  border-color: #f5af47ea;
}

.card.bg-warning .card-title {
  color: #fff;
}

.card.bg-info .card-header {
  background-color: #9465fcea;
  border-color: #9465fcea;
}

.card.bg-info .card-title {
  color: #fff;
}

.card.bg-dark .card-header {
  background-color: #242e44;
  border-color: #242e44;
}

.card.bg-dark .card-title {
  color: #fff;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #83d8ae;
}

.nav-pills .nav-link {
  border-radius: 10px;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link,
.nav-tabs .nav-link.active {
  border: 0;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  background: #83d8ae;
  color: #fff;
}

.toast {
  border-radius: 3px;
  border: none;
  box-shadow: 0 0 1.25rem rgb(31 45 61 / 8%);
  background-color: rgba(31, 31, 43, 0.7);
}

.toast-header {
  background-color: rgba(31, 31, 43, 0.95);
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  padding: 10px 15px;
  color: #fff;
}

.toast-body {
  padding: 15px;
}

.toast-header strong {
  font-weight: 500;
}

.alert {
  border-radius: 3px;
  padding: 15px 18px;
  font-weight: 500;
}

.alert-primary {
  background-color: #86c1ed;
  border-color: #86c1ed;
  color: #fff;
}

.alert-secondary {
  background-color: #e9f0f2;
  border-color: #e9f0f2;
  color: #5b6875;
}

.alert-success {
  background-color: #83d8ae;
  border-color: #83d8ae;
  color: #fff;
}

.alert-danger {
  background-color: #e8538f;
  border-color: #e8538f;
  color: #fff;
}

.alert-warning {
  background-color: #fad292;
  border-color: #fad292;
  color: #fff;
}

.alert-info {
  background-color: #ada6f2;
  border-color: #ada6f2;
  color: #fff;
}

.alert-light {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}

.alert-dark {
  background-color: #d1d3e0;
  border-color: #d1d3e0;
  color: #5b5b5b;
}

.alert-primary.light-alert {
  background-color: #d9edfc;
  border-color: #b7d4eb;
  color: #5ea5db;
}

.alert-secondary.light-alert {
  background-color: #e1eaed;
  border-color: #bfd0d6;
  color: #5b6875;
}

.alert-success.light-alert {
  background-color: #d8f2e5;
  border-color: #b2d4c3;
  color: #2f9c68;
}

.alert-danger.light-alert {
  background-color: #fce6e6;
  border-color: #dbbdbd;
  color: #c95b59;
}

.alert-warning.light-alert {
  background-color: #fcf1e1;
  border-color: #e3d5c1;
  color: #b5814a;
}

.alert-info.light-alert {
  background-color: #e6e3ff;
  border-color: #c0bce0;
  color: #7e78c2;
}

.alert-light.light-alert {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}

.alert-dark.light-alert {
  background-color: #d1d3e0;
  border-color: #242e44;
  color: #383d41;
}

.icon-list-row {
  margin-top: 30px;
  text-align: center;
}

.icon-list-row i {
  font-size: 23px;
}

.icon-state-info {
  color: #83d8ae;
}

.jstree-default .jstree-clicked,
.jstree-default .jstree-hovered {
  background: #1f1f2b;
}

.badge {
  font-weight: 500;
  padding: 7px 12px;
  font-size: 12px;
}

.badge:not(.badge-pill) {
  border-radius: 3px;
}

.badge.bg-primary {
  background-color: #e3f3ff !important;
  color: #5ea5db;
}

.badge.bg-secondary {
  background-color: #e9f0f2 !important;
  color: #5b6875 !important;
}

.badge.bg-success {
  background-color: #e1f7ec !important;
  color: #2f9c68;
}

.badge.bg-danger {
  background-color: #ffebeb !important;
  color: #c95b59;
}

.badge.bg-warning {
  background-color: #fff6e8 !important;
  color: #b5814a;
}

.badge.bg-info {
  background-color: #eae8ff !important;
  color: #7e78c2;
}

.badge.bg-dark {
  background-color: #d1d3e0 !important;
  color: #5b5b5b;
}

.badge-icon {
  width: 35px;
  height: 35px;
  padding: 10px;
}

.btn {
  padding: 8px 20px;
  border-radius: 3px;
  font-weight: 500;
}

.btn-primary,
.btn-primary.disabled,
.btn-primary:disabled {
  background-color: #86c1ed;
  border-color: #86c1ed;
  color: #fff;
}

.btn-primary.focus,
.btn-primary:focus,
.btn-primary:hover,
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active {
  background-color: #86c1ed;
  border-color: #86c1ed;
  color: #fff;
  box-shadow: 0 3px 18px -8px #86c1ed;
}

.btn-secondary,
.btn-secondary.disabled,
.btn-secondary:disabled {
  background-color: #e9f0f2;
  border-color: #e9f0f2;
  color: #355261;
}

.btn-secondary.focus,
.btn-secondary:focus,
.btn-secondary:hover,
.btn-secondary:not(:disabled):not(.disabled).active,
.btn-secondary:not(:disabled):not(.disabled):active {
  background-color: #e9f0f2;
  border-color: #e9f0f2;
  color: #355261;
  box-shadow: 0 3px 18px -8px #e9f0f2;
}

.btn-success,
.btn-success:disabled,
.btn-sucess.disabled {
  background-color: #83d8ae;
  border-color: #83d8ae;
  color: #fff;
}

.btn-success.focus,
.btn-success:focus,
.btn-success:hover,
.btn-success:not(:disabled):not(.disabled).active,
.btn-success:not(:disabled):not(.disabled):active {
  background-color: #83d8ae;
  border-color: #83d8ae;
  color: #fff;
  box-shadow: 0 3px 18px -8px #83d8ae;
}

.btn-danger,
.btn-danger.disabled,
.btn-danger:disabled {
  background-color: #e8538f;
  border-color: #e8538f;
  color: #fff;
}

.btn-danger.focus,
.btn-danger:focus,
.btn-danger:hover,
.btn-danger:not(:disabled):not(.disabled).active,
.btn-danger:not(:disabled):not(.disabled):active {
  background-color: #e8538f;
  border-color: #e8538f;
  color: #fff;
  box-shadow: 0 3px 18px -8px #e8538f;
}

.btn-warning,
.btn-warning.disabled,
.btn-warning:disabled {
  background-color: #fad292;
  border-color: #fad292;
  color: #fff;
}

.btn-warning.focus,
.btn-warning:focus,
.btn-warning:hover,
.btn-warning:not(:disabled):not(.disabled).active,
.btn-warning:not(:disabled):not(.disabled):active {
  background-color: #fad292;
  border-color: #fad292;
  color: #fff;
  box-shadow: 0 3px 18px -8px #fad292;
}

.btn-info,
.btn-info.disabled,
.btn-info:disabled {
  background-color: #ada6f2;
  border-color: #ada6f2;
  color: #fff;
}

.btn-info.focus,
.btn-info:focus,
.btn-info:hover,
.btn-info:not(:disabled):not(.disabled).active,
.btn-info:not(:disabled):not(.disabled):active {
  background-color: #ada6f2;
  border-color: #ada6f2;
  color: #fff;
  box-shadow: 0 3px 18px -8px #ada6f2;
}

.btn-light,
.btn-light.disabled,
.btn-light:disabled {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
  color: #7e8299;
}

.btn-light:focus,
.btn-light:hover .btn-light.focus,
.btn-light:not(:disabled):not(.disabled).active,
.btn-light:not(:disabled):not(.disabled):active {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
  color: #7e8299;
  box-shadow: 0 3px 18px -8px #f3f6f9;
}

.btn-dark,
.btn-dark.disabled,
.btn-dark:disabled {
  background-color: #d1d3e0;
  border-color: #d1d3e0;
  color: #5b5b5b;
}

.btn-dark.focus,
.btn-dark:focus,
.btn-dark:hover,
.btn-dark:not(:disabled):not(.disabled).active,
.btn-dark:not(:disabled):not(.disabled):active {
  background-color: #d1d3e0;
  border-color: #d1d3e0;
  color: #5b5b5b;
  box-shadow: 0 3px 18px -8px #d1d3e0;
}

.btn-circle {
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 50%;
}

.btn-link {
  color: #83d8ae;
  text-decoration: none;
  border: none;
}

.btn-link:hover {
  color: #83d8ae;
  text-decoration: underline;
}

.btn-outline-primary {
  color: #86c1ed;
  border-color: #86c1ed;
}

.btn-outline-primary.focus,
.btn-outline-primary:focus,
.btn-outline-primary:hover,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.btn-outline-primary:not(:disabled):not(.disabled):active {
  color: #fff;
  border-color: #86c1ed;
  background-color: #86c1ed;
  box-shadow: 0 3px 18px -8px #86c1ed;
}

.btn-outline-secondary {
  color: #e9f0f2;
  border-color: #e9f0f2;
}

.btn-outline-secondary.focus,
.btn-outline-secondary:focus,
.btn-outline-secondary:hover,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.btn-outline-secondary:not(:disabled):not(.disabled):active {
  color: #355261;
  border-color: #e9f0f2;
  background-color: #e9f0f2;
  box-shadow: 0 3px 18px -8px #e9f0f2;
}

.btn-outline-success {
  color: #83d8ae;
  border-color: #83d8ae;
}

.btn-outline-success.focus,
.btn-outline-success:focus,
.btn-outline-success:hover,
.btn-outline-success:not(:disabled):not(.disabled).active,
.btn-outline-success:not(:disabled):not(.disabled):active {
  color: #fff;
  border-color: #83d8ae;
  background-color: #83d8ae;
  box-shadow: 0 3px 18px -8px #83d8ae;
}

.btn-outline-danger {
  color: #e8538f;
  border-color: #e8538f;
}

.btn-outline-danger.focus,
.btn-outline-danger:focus,
.btn-outline-danger:hover,
.btn-outline-danger:not(:disabled):not(.disabled).active,
.btn-outline-danger:not(:disabled):not(.disabled):active {
  color: #fff;
  border-color: #e8538f;
  background-color: #e8538f;
  box-shadow: 0 3px 18px -8px #e8538f;
}

.btn-outline-warning {
  color: #fad292;
  border-color: #fad292;
}

.btn-outline-warning.focus,
.btn-outline-warning:focus,
.btn-outline-warning:hover,
.btn-outline-warning:not(:disabled):not(.disabled).active,
.btn-outline-warning:not(:disabled):not(.disabled):active {
  color: #fff;
  border-color: #fad292;
  background-color: #fad292;
  box-shadow: 0 3px 18px -8px #fad292;
}

.btn-outline-info {
  color: #ada6f2;
  border-color: #ada6f2;
}

.btn-outline-info.focus,
.btn-outline-info:focus,
.btn-outline-info:hover,
.btn-outline-info:not(:disabled):not(.disabled).active,
.btn-outline-info:not(:disabled):not(.disabled):active {
  color: #fff;
  border-color: #ada6f2;
  background-color: #ada6f2;
  box-shadow: 0 3px 18px -8px #ada6f2;
}

.btn-outline-dark {
  color: #5b5b5b;
  border-color: #d1d3e0;
}

.btn-outline-dark.focus,
.btn-outline-dark:focus,
.btn-outline-dark:hover,
.btn-outline-dark:not(:disabled):not(.disabled).active,
.btn-outline-dark:not(:disabled):not(.disabled):active {
  color: #5b5b5b;
  border-color: #d1d3e0;
  background-color: #d1d3e0;
  box-shadow: 0 3px 18px -8px #d1d3e0;
}

body.modal-open {
  overflow: visible;
}

.modal-content {
  border-radius: 3px;
  border: none;
}

.modal-header {
  padding: 30px;
  border: 0;
  color: #5b5b5b;
}

.modal-footer {
  padding: 30px;
  border: 0;
}

.modal-body {
  padding: 0 30px;
  color: #5b5b5b;
}

.modal-backdrop {
  z-index: 11000;
}

.modal {
  z-index: 11001;
}

.dropdown-header {
  color: #fff;
}

.dropdown-menu {
  background: #1f1f2b;
  border-radius: 5px;
  border: none;
  box-shadow: 0 0 1.25rem rgb(31 45 61 / 5%);
  padding: 15px 0;
  margin: 10px 0;
}

.dropdown-item {
  color: #9a9cab;
  padding: 9px 26px;
}

.dropdown-item:hover {
  background: 0 0;
  color: #e85382;
}

.dropdown-divider {
  border-color: #2b2b3b;
}

.dropdown-menu-dark {
  background-color: #1f1f2b;
  color: #565673;
}

.dropdown-menu-dark .dropdown-item {
  color: #9a9cab;
}

.dropdown-menu-dark .dropdown-item:hover {
  background: 0 0;
  color: #83d8ae;
}

.dropdown-menu-dark .dropdown-item.active,
.dropdown-menu-dark .dropdown-item:active {
  color: #83d8ae;
  background: 0 0;
}

.dropdown-item.active,
.dropdown-item:active {
  color: #83d8ae;
  background: 0 0;
}

.dropdown-header {
  padding: 8px 26px;
}

.dropdown-menu form {
  padding: 8px 20px;
}

.page-link {
  color: #9a9cab;
  border-color: #2b2b3b;
  background-color: #1f1f2b;
  padding: 8px 11px;
}

.page-link:hover {
  opacity: 0.8;
  background-color: #1f1f2b;
  border-color: #2b2b3b;
  color: #9a9cab;
}

.page-item.disabled .page-link {
  border-color: #2b2b3b;
  background-color: #1f1f2b;
  opacity: 0.8;
}

.page-item:first-child .page-link {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.page-item:last-child .page-link {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.page-item.active .page-link {
  background-color: #83d8ae;
  border-color: #83d8ae;
}

.progress {
  background-color: #1f1f2b;
  border-radius: 2px;
}

.progress-bar {
  background-color: #86c1ed;
}

.accordion-button {
  border: none;
  background-color: #1f1f2b;
  box-shadow: 0 0 7px 0 rgba(63, 71, 105, 0.08);
  padding: 15px 18px;
  color: #9a9cab;
}

.accordion-collapse {
  border: none;
}

.accordion-button:not(.collapsed) {
  background-color: #1f1f2b;
  color: #83d8ae;
}

.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.accordion-flush .accordion-button {
  box-shadow: none;
}

.accordion-flush .accordion-item .accordion-button {
  background: 0 0;
}

.form-control {
  border-color: #2d2d3f;
  background: #1f1f2b;
  border-radius: 3px;
  padding: 0.65rem 1rem;
  color: #fff !important;
}

.form-control:focus {
  border-color: #2d2d3f;
  background: #181821;
}

.form-control:disabled,
.form-control[readonly],
.form-select:disabled {
  border-color: #2d2d3f;
  background: #181821;
  opacity: 0.8;
}

.form-control-color {
  padding: 7px;
}

.form-select {
  border-color: #2d2d3f;
  background: #181821;
  color: #9a9cab;
  border-radius: 3px;
  padding: 0.65rem 1rem;
}

.form-check-input {
  background: #1f1f2b;
  border: 1px solid #2d2d3f;
}

.form-check-input:checked {
  background-color: #e8538f;
  border-color: #e8538f;
}

.input-group-text {
  border-radius: 3px;
  background-color: #181821;
  border-color: #2d2d3f;
  color: #fff;
}

.form-control.is-valid,
.form-select.is-valid,
.was-validated .form-control:valid,
.was-validated .form-select:valid {
  border-color: #83d8ae;
}

.form-check-input.is-valid ~ .form-check-label,
.valid-feedback,
.was-validated .form-check-input:valid ~ .form-check-label {
  color: #83d8ae;
}

.form-check-input.is-valid:checked,
.was-validated .form-check-input:valid:checked {
  background-color: #83d8ae;
  border-color: #83d8ae;
}

.form-control.is-invalid,
.form-select.is-invalid,
.was-validated .form-control:invalid,
.was-validated .form-select:invalid {
  border-color: #e8538f;
}

.invalid-feedback {
  color: #e8538f;
}

.form-check-input.is-invalid ~ .form-check-label,
.was-validated .form-check-input:invalid ~ .form-check-label {
  color: #e8538f;
}

.form-check-input.is-invalid,
.was-validated .form-check-input:invalid {
  border-color: #e8538f;
}

.table {
  color: #9a9cab;
  border-color: #e4e6ef;
}

.table img {
  margin-right: 10px;
}

.table-primary {
  --bs-table-bg: #86c1ed;
  --bs-table-striped-bg: #86c1ed;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #86c1ed;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #86c1ed;
  --bs-table-hover-color: #000;
  color: #fff;
  border-color: #86c1ed;
}

.table-secondary {
  --bs-table-bg: #e9f0f2;
  --bs-table-striped-bg: #e9f0f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e9f0f2;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e9f0f2;
  --bs-table-hover-color: #000;
  color: #5b6875;
  border-color: #e9f0f2;
}

.table-success {
  --bs-table-bg: #83d8ae;
  --bs-table-striped-bg: #83d8ae;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #83d8ae;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #83d8ae;
  --bs-table-hover-color: #000;
  color: #fff;
  border-color: #83d8ae;
}

.table-danger {
  --bs-table-bg: #e8538f;
  --bs-table-striped-bg: #e8538f;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e8538f;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e8538f;
  --bs-table-hover-color: #000;
  color: #fff;
  border-color: #e8538f;
}

.table-warning {
  --bs-table-bg: #fad292;
  --bs-table-striped-bg: #fad292;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #fad292;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #fad292;
  --bs-table-hover-color: #000;
  color: #fff;
  border-color: #fad292;
}

.table-info {
  --bs-table-bg: #ada6f2;
  --bs-table-striped-bg: #ada6f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #ada6f2;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ada6f2;
  --bs-table-hover-color: #000;
  color: #fff;
  border-color: #ada6f2;
}

.table-light {
  --bs-table-bg: #f3f6f9;
  --bs-table-striped-bg: #f3f6f9;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #f3f6f9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #f3f6f9;
  --bs-table-hover-color: #000;
  color: #5b5b5b;
  border-color: #f3f6f9;
}

.table-dark {
  --bs-table-bg: #d1d3e0;
  --bs-table-striped-bg: #d1d3e0;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #d1d3e0;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #d1d3e0;
  --bs-table-hover-color: #fff;
  color: #5b5b5b;
  border-color: #d1d3e0;
}

.table-dark th {
  background-color: #d1d3e0;
}

.table-light th {
  background-color: #f3f6f9;
}

.table * {
  border-color: #262635 !important;
}

.table td,
.table th {
  padding: 15px 20px !important;
  font-weight: 400;
  vertical-align: middle;
}

.table tbody tr:last-child td,
.table tbody tr:last-child th {
  border-bottom: none;
}

.table tfoot tr td,
.table tfoot tr th {
  border-bottom: none;
  border-top-width: 1px;
}

.table-hover > tbody > tr {
  transition: all 0.2s ease-in-out;
}

.table-hover > tbody > tr:hover {
  --bs-table-hover-bg: transparent;
  background: #1f1f2b;
  color: #9a9cab;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-striped-bg: #181821;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  color: #9a9cab;
}

.blockUI.blockOverlay {
  border-radius: inherit;
  background: rgba(24, 24, 33) !important;
  opacity: 0.8 !important;
}

.blockUI.blockMsg {
  background: 0 0 !important;
  width: 25px !important;
  border: 0 !important;
  height: 25px !important;
  left: calc(50% - 12.5px) !important;
  top: calc(50% - 12.5px) !important;
}

table.dataTable {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

table.dataTable td,
table.dataTable th {
  padding: 15px 25px !important;
  border-bottom: 1px solid #262635 !important;
}

table.dataTable tfoot th {
  border-bottom: 0 !important;
}

table.dataTable tfoot th,
table.dataTable thead th {
  font-weight: 700;
  text-transform: uppercase;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: #9a9cab;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_desc_disabled:before {
  content: "\\f077";
  font-family: "Font Awesome 5 Free";
  font-size: 14px;
  right: 10px;
  bottom: calc(50% - 4px);
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_desc_disabled:after {
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  font-size: 14px;
  right: 10px;
  bottom: calc(50% - 14px);
}

div.dataTables_wrapper div.dataTables_length select {
  margin: 0 10px;
}

div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 10px;
}

tr.group {
  background-color: #181821 !important;
}

.select2 input {
  color: #fff;
}

.select2-selection {
  height: auto !important;
  padding: 10px;
  border-radius: 3px !important;
  box-shadow: none;
  border: 1px solid #2d2d3f !important;
}

.select2-container--default .select2-selection--multiple,
.select2-container--default .select2-selection--single {
  background-color: #181821;
}

.select2-selection .select2-selection__rendered {
  line-height: 1.5 !important;
  padding-left: 0 !important;
  font-size: 13px;
  color: #9a9cab !important;
}

.select2-selection .select2-selection__arrow {
  height: 41px !important;
  right: 20px !important;
}

.select2-selection.select2-selection--multiple {
  padding: 7px 1rem !important;
  min-height: 0 !important;
}

.select2-selection.select2-selection--multiple .select2-selection__rendered {
  margin-top: 3px;
  margin-bottom: -3px;
}

.select2-selection.select2-selection--multiple
  .select2-selection__rendered
  input {
  margin-top: 0 !important;
}

.select2-search--dropdown .select2-search__field {
  padding: 0.65rem 1rem;
  height: auto;
  border-radius: 3px;
  border: 1px solid #37374d;
  font-size: 13px;
  color: #fff;
  background-color: #1f1f2b;
}

.select2-search--dropdown .select2-search__field:active,
.select2-search--dropdown .select2-search__field:focus {
  box-shadow: none !important;
  border-color: #37374d !important;
  outline: 0;
}

.select2-dropdown {
  background-color: #1f1f2b;
  padding: 12px 25px !important;
  border: none;
  margin-top: 3px !important;
  border-radius: 3px !important;
  box-shadow: 0 0 1.25rem rgba(31, 45, 61, 0.04);
}

.select2-dropdown--above {
  margin-top: -3px !important;
  border-bottom: 1px solid #2d2d3f !important;
}

.select2-selection__choice {
  margin-top: 0 !important;
  height: 19px !important;
  border: 0 !important;
  background: #1f1f2b !important;
  color: #5fd0a5 !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  padding: 0 10px;
}

.select2-results__option {
  border-radius: 20px;
  padding: 0.65rem 1rem;
}

.select2-selection__choice span {
  color: #9a9cab !important;
}

.select2-container--default .select2-results__option .select2-results__option {
  border-radius: 20px;
  margin: 2px 0;
  padding: 0.65rem 1rem;
  transition: all 0.2s ease-in-out;
}

.select2-container--default
  .select2-results__option--highlighted[aria-selected] {
  background: #1f1f2b;
  color: #83d8ae;
}

.select2-container--default
  .select2-results__option[aria-selected="true"]:hover {
  color: #fff;
}

.select2-container--default .select2-results__group {
  padding: 6px;
  font-size: 11px;
  text-transform: uppercase;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  opacity: 0.7;
}

.select2-container--default .select2-results__option[aria-selected="true"] {
  color: #fff;
  border: none;
  background: #1f1f2b;
}

.error-page .container,
.error-page .error-container {
  height: 100%;
  position: relative;
}

.error-info {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.error-info h1 {
  font-size: 148px;
  color: #83d8ae;
}

.error-info p {
  font-size: 14px;
}

.error-image {
  position: absolute;
  right: 0;
  height: 100%;
  width: 50%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  background-size: contain;
}

body.err-500 .error-image {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  background-size: contain;
}

body.error-page .container {
  max-width: 1140px;
}

.invoice-details {
  margin-top: 20px;
  margin-bottom: 40px;
}

.invoice-details p {
  margin-bottom: 3px;
}

.invoice-details p.info {
  font-weight: 500;
  text-transform: uppercase;
  color: #9a9cab;
  margin-bottom: 10px;
}

.invoice-info p {
  margin-bottom: 8px;
}

.invoice-info p span {
  float: right;
}

.invoice-table th {
  font-weight: 500;
}

.invoice-table img {
  width: 35px;
  height: 35px;
  border-radius: 3px;
}

.invoice-table a {
  color: #5b5b5b;
  margin-right: 5px;
}

.invoice-table svg {
  width: 18px;
  height: 18px;
}

.invoice-last {
  margin-top: 40px;
}

.login-page .container,
.login-page .container .row {
  height: 100vh;
}

.login-page .container .row .login-box-container {
  top: 50%;
  transform: translateY(-50%);
}

.authent-logo {
  text-align: center;
}

.authent-logo img {
  border-radius: 3px;
  margin-bottom: 10px;
}

.authent-logo a {
  font-size: 20px;
  font-weight: 500;
}

.authent-text {
  text-align: center;
  margin: 10px 0 15px 0;
  font-size: 16px;
}

.authent-text p {
  margin-bottom: 5px;
}

.authent-reg {
  text-align: center;
  margin-top: 20px;
}

.authent-reg p {
  margin-bottom: 0;
}

.authent-login {
  margin-top: 10px;
  text-align: center;
}

.authent-login p {
  margin-bottom: 0;
}

.st-pricing-table {
  text-align: center;
}

.st-pricing-table li {
  padding: 20px;
}

.st-pricing-table-header {
  color: #fff;
}

.email-page .main-wrapper {
  padding-bottom: 0;
}

.email-page .main-wrapper > .row > div > .card {
  margin-bottom: 0;
}

.email-list {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}

.email-list ul {
  margin-bottom: 0;
}

.email-list-item {
  color: #9a9cab;
}

.email-list-item .email-author img {
  width: 35px;
  border-radius: 5px;
}

.email-list-item .email-author span.author-name {
  margin-left: 7px;
  line-height: 25px;
  color: #fff;
}

.email-list-item .email-author span.email-date {
  float: right;
  opacity: 0.6;
  line-height: 25px;
  font-size: 12px;
}

.email-list-item .email-info {
  display: block;
  margin-top: 8px;
}

.email-list-item .email-info .email-subject {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
}

.email-list-item .email-info .email-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  opacity: 0.6;
}

.email-list li a:active,
.email-list li a:focus,
.email-menu li a:active,
.email-menu li a:focus {
  color: #5b5b5b;
}

.email-list li a {
  border-radius: 5px;
  display: block;
  padding: 18px 12px;
  transition: all 0.2s ease-in-out;
}

.email-list li:last-child a {
  border-color: transparent;
}

.email-list li a:hover {
  background: #1f1f2b;
}

.email-list li.active a {
  margin-bottom: 5px;
  background: #1f1f2b;
}

.open-email-content {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}

.mail-header {
  width: 100%;
  display: block;
  overflow: hidden;
}

.mail-title {
  float: left;
  line-height: 20px;
  padding: 4px 0;
  max-width: calc(100% - 285px);
  color: #fff;
}

.mail-actions {
  float: right;
}

.mail-info {
  display: block;
  width: 100%;
  overflow: hidden;
  padding-top: 20px;
  padding-bottom: 30px;
  border-bottom: 1px solid #262635;
}

.mail-info .mail-author {
  float: left;
}

.mail-info .mail-author img {
  width: 50px;
  border-radius: 5px;
  float: left;
}

.mail-info .mail-author-info {
  padding: 0 10px;
  display: inline-block;
  height: 50px;
}

.mail-info .mail-author span.mail-author-name {
  display: block;
  line-height: 25px;
}

.mail-info .mail-author span.mail-author-address {
  display: block;
  line-height: 25px;
  opacity: 0.6;
}

.mail-info .mail-other-info {
  float: right;
}

.mail-info .mail-other-info span {
  line-height: 50px;
}

.mail-text {
  margin-top: 30px;
}

.mail-attachment {
  margin-top: 30px;
}

.mail-attachment-files {
  margin-top: 30px;
}

.mail-attachment-files .card {
  width: 200px;
  float: left;
  margin-right: 20px;
}

.mail-attachment-files .card .card-body {
  padding: 15px;
  font-size: 14px;
}

.mail-attachment-files .card .card-title {
  margin-bottom: 10px;
  font-size: 14px;
}

.card-subtitle {
  color: #fff;
}

.file-manager-menu ul li {
  padding: 10px;
}

.file-manager-menu ul li {
  transition: all 0.1s ease-in-out;
}

.file-manager-menu ul li a:hover {
  margin-left: 5px;
}

.file-manager-menu ul li a {
  color: #9a9cab;
  transition: all 0.1s ease-in-out;
}

.file-manager-menu ul li a i {
  padding-right: 10px;
}

.file-manager-menu.label-menu ul li a i {
  width: 6px;
  height: 10px;
  border-radius: 50%;
  background: #000;
  display: inline-block;
  vertical-align: middle;
  margin: 0 16px 0 6px;
}

.file-manager-header {
  color: #fff;
}

.fmm-title {
  padding: 10px;
  display: block;
  color: #fff;
}

.file-manager-menu .progress {
  margin-top: 10px;
  margin-left: 10px;
}

.storage-info-text {
  padding: 10px;
}

.card-file-manager .card-text {
  opacity: 0.7;
}

.card-file-header {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  vertical-align: middle;
  font-size: 40px;
  text-align: center;
  line-height: 130px;
  background: #1f1f2b;
}

.folder .folder-icon {
  float: left;
}

.folder .folder-icon i {
  font-size: 43px;
  color: #9a9cab;
}

.folder .folder-info {
  display: block;
  margin-left: 20px;
  float: left;
}

.folder .folder-info a {
  margin-bottom: 0;
  display: block;
  color: #9a9cab;
}

.profile-cover {
  width: 100%;
  display: block;
  position: relative;
  border-radius: 15px;
  z-index: 1;
  height: 250px;
  /* height: 350px; */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center center no-repeat;
  background-size: cover;
}

.profile-cover:after {
  display: block;
  content: " ";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 15px;
  background: linear-gradient(rgba(0, 0, 0, 0.3), #000);
}

.profile-header {
  display: block;
  width: 100%;
  margin-top: -110px;
  padding: 0 30px;
  overflow: hidden;
  z-index: 2;
  position: relative;
  margin-bottom: 20px;
}

.profile-header .profile-img img {
  width: 150px;
  height: 150px;
  border-radius: 150px;
}

.profile-header .profile-img {
  float: left;
}

.profile-header .profile-name {
  float: left;
  margin-top: 50px;
  margin-left: 30px;
}

.profile-header .profile-name h3 {
  color: #fff;
  font-weight: 400;
  font-size: 22px;
  line-height: 50px;
}

.profile-header .profile-header-menu {
  float: right;
  height: 100%;
  margin-top: 39px;
}

.profile-header .profile-header-menu ul li {
  float: left;
  height: 100%;
  padding: 25px;
}

.profile-header .profile-header-menu ul li a {
  color: #7d7d83;
  display: block;
  font-weight: 400;
  transition: all 0.2s ease-in-out;
}

.profile-header .profile-header-menu ul li a.active,
.profile-header .profile-header-menu ul li a:hover {
  color: #fff;
}

ul.profile-about-list {
  margin-bottom: 0;
}

ul.profile-about-list li {
  margin-bottom: 10px;
}

ul.profile-about-list li.profile-about-list-buttons {
  margin-bottom: 0;
}

.story-list .story {
  overflow: hidden;
  display: block;
  margin-bottom: 10px;
}

.story-list .story:last-child {
  margin-bottom: 0;
}

.story-list .story img {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  border: 2px solid #86c1ed;
  padding: 2px;
  float: left;
}

.story-list .story .story-info {
  float: left;
  padding: 5px 15px;
}

.story-list .story .story-info span.story-author {
  display: block;
  line-height: 20px;
  color: #9a9cab;
}

.story-list .story .story-info span.story-time {
  line-height: 20px;
  font-size: 13px;
  opacity: 0.6;
}

.post-body,
.post-header {
  display: block;
  overflow: hidden;
  width: 100%;
}

.post-header img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  float: left;
}

.post-header .post-info {
  float: left;
  padding: 4px 15px 0 15px;
}

.post-header .post-info span.post-date {
  font-size: 13px;
  opacity: 0.6;
}

.post-header .post-header-actions {
  float: right;
  padding: 15px 0;
}

.post-header .post-header-actions a {
  line-height: 20px;
  color: #646464;
}

.post-header .post-header-actions a:hover {
  color: #333;
}

.post-body {
  padding: 15px 0 0 0;
  position: relative;
}

.post-body p {
  margin-bottom: 0;
}

.post-header .post-info span.post-author {
  font-size: 15px;
}

.post-body .post-image {
  display: block;
  width: 100%;
  border-radius: 6px;
  margin-top: 15px;
  max-height: 500px;
  object-fit: contain;
}

.post-actions,
.post-actions ul {
  display: block;
  overflow: hidden;
  margin-bottom: 0;
}

.post-actions {
  margin-top: 15px;
  padding: 5px 10px 0;
}

.post-actions ul li a {
  float: left;
  padding: 5px 8px;
  font-size: 15px;
  color: #9a9cab;
  margin-right: 10px;
}

.post-actions ul li a:hover {
  color: #83d8ae;
}

.post-actions ul li a.liked {
  color: #844ff1;
}

.post-actions ul li a.liked i:before {
  content: "\\f004";
}

.post-actions ul li a i {
  margin-right: 7px;
}

.post-comments {
  margin-top: 5px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.post-comments .post-comm {
  display: block;
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 15px;
  overflow: hidden;
}

.post-comments .post-comm:last-child {
  margin-bottom: 0;
}

.post-comments .post-comm img {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  float: left;
}

.post-comments .post-comm .comment-container {
  float: left;
  padding: 0 10px;
  width: calc(100% - 30px);
  display: block;
}

.post-comments .post-comm .comment-container span.comment-author {
  color: #fff;
  display: block;
  line-height: 30px;
}

.post-comments .post-comm .comment-container span.comment-author small {
  float: right;
  font-size: 13px;
  color: #9a9cab;
  /* opacity: 0.6; */
}

.post-comments .post-comm .comment-text {
  padding: 10px 0 0 0;
  display: inline-block;
  margin-left: 40px;
}

.fc-toolbar h2 {
  font-size: 20px !important;
  font-weight: 400;
  color: #fff;
}

.fc-next-button.fc-button.fc-button-primary,
.fc-next-button.fc-button.fc-button-primary.active,
.fc-next-button.fc-button.fc-button-primary:focus,
.fc-prev-button.fc-button.fc-button-primary,
.fc-prev-button.fc-button.fc-button-primary.active,
.fc-prev-button.fc-button.fc-button-primary:focus {
  background-color: #83d8ae;
  border-color: #83d8ae;
  color: #fff;
  border-radius: 3px;
  padding: 8px 5px;
}

.fc-next-button.fc-button.fc-button-primary:hover,
.fc-prev-button.fc-button.fc-button-primary:hover {
  background-color: #83d8ae;
  border-color: #83d8ae;
  color: #fff;
  box-shadow: 0 3px 18px -8px #83d8ae;
}

.fc-today-button.fc-button.fc-button-primary,
.fc-today-button.fc-button.fc-button-primary.active,
.fc-today-button.fc-button.fc-button-primary:focus {
  background-color: #e9f0f2;
  border-color: #e9f0f2;
  color: #355261;
  border-radius: 3px;
  padding: 8px 20px;
}

.fc .fc-button-primary:disabled {
  background-color: #e9f0f2;
  border-color: #e9f0f2;
  color: #355261;
}

#calendar a {
  color: #9a9cab;
}

.fc-col-header-cell-cushion {
  font-weight: 400;
}

.fc .fc-daygrid-day.fc-day-today {
  background-color: #d8f2e5;
}

.fc-scrollgrid-section.fc-scrollgrid-section-header {
  border: none;
}

.fc-h-event {
  background-color: #83d8ae;
  border-color: #83d8ae;
  color: #fff;
  padding: 3px;
  border-radius: 3px;
}

.fc-event-title.fc-sticky {
  padding: 2px 10px;
  color: #fff;
  font-weight: 500;
}

.fc-daygrid-event {
  border-radius: 15px;
}

.fc-daygrid-event:hover {
  background-color: #83d8ae;
  border-color: #83d8ae;
}

.fc-daygrid-dot-event .fc-event-title {
  font-weight: 400;
}

.fc-daygrid-event-dot {
  border-color: #83d8ae;
}

.fc table,
.fc-theme-standard td,
.fc-theme-standard th {
  border-color: #262635 !important;
}

.card.stats-card {
  padding: 6px 0;
}

.stats-card .stats-info {
  float: left;
}

.stats-card .card-title {
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 0;
}

.stats-card .card-title span.stats-change {
  font-size: 14px;
  vertical-align: text-top;
  margin-left: 10px;
}

.stats-card .card-title span.stats-change.stats-change-success {
  color: #83d8ae;
}

.stats-card .card-title span.stats-change.stats-change-danger {
  color: #e8538f;
}

.stats-card .stats-text {
  margin-bottom: 0;
  line-height: 25px;
  margin-top: 10px;
  font-size: 13px;
  color: #9a9cab;
}

.stats-card .stats-icon {
  float: right;
  padding: 10px;
  border-radius: 5px;
  line-height: 1;
  margin: 11px 15px 0 0;
}

.stats-card .stats-icon.change-success {
  color: #fff;
  background-color: #83d8ae;
  box-shadow: 0 3px 18px -8px #83d8ae;
}

.stats-card .stats-icon.change-danger {
  color: #fff;
  background: #e8538f;
  box-shadow: 0 3px 18px -8px #e8538f;
}

.stats-card .stats-icon i {
  line-height: 1;
}

.widget-info .widget-info-container {
  text-align: center;
}

.widget-info .widget-info-container .widget-info-image {
  width: 100%;
  height: 158px;
  background-size: 191px !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
}

.widget-info .widget-info-container .widget-info-title {
  margin: 21px 0;
}

.widget-info .widget-info-container .widget-info-text {
  text-align: center;
  color: #9a9cab;
}

.widget-info .widget-info-container .widget-info-action {
  margin: 14px 0 10px;
  display: inline-block;
}

.transactions-list {
  margin-bottom: 25px;
}

.transactions-list:last-child {
  margin-bottom: 0;
}

.tr-item {
  display: flex;
  justify-content: space-between;
}

.tr-item .tr-text h4 {
  font-size: 14px;
  margin-bottom: 2px;
}

.tr-item .tr-text p {
  font-size: 12px;
  margin-bottom: 0;
  color: #9a9cab;
}

.tr-company-name {
  display: flex;
}

.tr-rate {
  align-self: center;
}

.tr-rate p {
  margin-bottom: 0;
}

.tr-icon {
  margin-right: 16px;
}

.tr-card-icon {
  border-radius: 5px;
  width: 44px;
  height: 44px;
  padding: 9px 13px;
}

.tr-card-icon svg {
  width: 20px;
  height: 20px;
}

.tr-text {
  align-self: center;
}

.tr-text a {
  color: #5b5b5b;
}

.tr-img {
  margin-right: 16px;
}

.tr-img img {
  width: 44px;
  height: 44px;
  border-radius: 5px;
}

.tr-card-bg-primary {
  background-color: #86c1ed !important;
  box-shadow: 0 3px 18px -8px #86c1ed;
}

.tr-card-bg-secondary {
  background-color: #e9f0f2 !important;
  box-shadow: 0 3px 18px -8px #e9f0f2;
}

.tr-card-bg-success {
  background-color: #83d8ae !important;
  box-shadow: 0 3px 18px -8px #83d8ae;
}

.tr-card-bg-danger {
  background-color: #e8538f !important;
  box-shadow: 0 3px 18px -8px #e8538f;
}

.tr-card-bg-warning {
  background-color: #fad292 !important;
  box-shadow: 0 3px 18px -8px #fad292;
}

.tr-card-bg-info {
  background-color: #ada6f2 !important;
  box-shadow: 0 3px 18px -8px #ada6f2;
}

@media (min-width: 768px) {
  .actions-widget .card-body {
    display: flex;
  }

  .actions-widget .actions-widget-item {
    flex: 1 1;
  }

  .actions-widget .actions-widget-item .actions-widget-item-title {
    margin-bottom: 0 !important;
  }
}

.actions-widget .actions-widget-item .actions-widget-item-title {
  margin: 14px 0;
  display: block;
}

.actions-widget .btn {
  width: 70px;
  height: 70px;
  margin: 0 20px;
  border: 1px solid #2d2d40;
  background-color: #262635;
}

.actions-widget .btn:hover {
  box-shadow: 0 3px 18px -8px #2d2d40;
}

.actions-widget .btn i {
  font-size: 20px;
}

.crypto-table img {
  width: 30px;
  margin: 5.3px 10px 5.2px 0;
}

.contact-card img {
  width: 80px;
  border-radius: 5px;
}

.contact-card-info {
  margin-top: 30px;
  margin-bottom: 30px;
}

.contact-card-info h6 {
  color: #fff;
  font-size: 15px;
}

.contact-card-buttons .btn {
  margin: 0 3px;
}

#sparkline1,
#sparkline2,
#sparkline3,
#sparkline4,
#sparkline5,
#sparkline6 {
  text-align: center;
}

.jqstooltip {
  box-sizing: content-box;
}

.loader {
  position: fixed;
  height: 100%;
  width: 100%;
  background: #fff;
  z-index: 11000;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transition: all 0.2s ease-in-out;
}

.loader .spinner-grow {
  top: 50%;
  left: 50%;
  margin: -20px 0 0 -20px;
  position: absolute;
  width: 40px;
  height: 40px;
  color: #86c1ed;
}

.no-loader .loader {
  visibility: hidden;
  opacity: 0;
}

.pace .pace-progress {
  z-index: 999999;
}

.activity-sidebar {
  z-index: 10001;
  width: 700px;
  background-color: #181821;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  transform: translateX(700px);
  overflow: auto;
  transition: all 0.2s ease-in-out;
  padding: 20px 30px 0 30px;
}

.activity-sidebar-show .activity-sidebar {
  transform: translateX(0);
}

.activity-sidebar-overlay {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.8);
  display: block;
}

.activity-sidebar-show .activity-sidebar-overlay {
  visibility: visible;
  opacity: 0.4;
}

#activity-sidebar-close {
  position: absolute;
  right: 30px;
  cursor: pointer;
}

.activity-header {
  margin-bottom: 30px;
  margin-top: 5px;
}

.activity-header h5 {
  color: #fff;
}

#activity-sidebar-close i {
  padding: 7px 0;
  color: #9a9cab;
}

.activity-list .activity-item {
  padding: 20px;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 10px;
  border: 1px solid #262635;
}

.activity-list .activity-item .activity-icon {
  float: left;
  padding: 5px;
  border-radius: 5px;
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 30px;
  margin-right: 15px;
  background: #83d8ae;
  color: #fff;
  box-shadow: 0 3px 18px -8px #83d8ae;
}

.activity-list .activity-item.activity-primary .activity-icon {
  background: #86c1ed;
  color: #fff;
  box-shadow: 0 3px 18px -8px #86c1ed;
}

.activity-list .activity-item.activity-secondary .activity-icon {
  background: #e9f0f2;
  color: #5b6875;
  box-shadow: 0 3px 18px -8px #e9f0f2;
}

.activity-list .activity-item.activity-danger .activity-icon {
  background: #e8538f;
  color: #fff;
  box-shadow: 0 3px 18px -8px #e8538f;
}

.activity-list .activity-item.activity-warning .activity-icon {
  background: #fad292;
  color: #fff;
  box-shadow: 0 3px 18px -8px #fad292;
}

.activity-list .activity-item.activity-info .activity-icon {
  background: #ada6f2;
  color: #fff;
  box-shadow: 0 3px 18px -8px #ada6f2;
}

.activity-list .activity-item .activity-icon i {
  line-height: 30px;
}

.activity-list .activity-item .activity-text {
  float: left;
  line-height: 20px;
  color: #fff;
  font-size: 14px;
  margin-top: 1px;
}

.activity-list .activity-item .activity-text span {
  clear: both;
  display: block;
  font-size: 13px;
  color: #9a9cab;
  padding-top: 2px;
}

.activity-list .activity-item .activity-helper {
  float: right;
  line-height: 50px;
  color: #9a9cab;
  font-size: 13px;
}

.search-results {
  visibility: hidden;
  opacity: 0;
  position: fixed;
  top: 90px;
  bottom: 0;
  left: 220px;
  right: 30px;
  z-index: 999;
  background: #181821;
  transition: all 0.2s ease-in-out;
  overflow-y: auto;
}

.page-sidebar-collapsed .search-results {
  left: 100px;
}

.search-results .search-results-header {
  padding: 40px 19.5px 10px 49.5px;
  overflow: hidden;
  display: block;
  margin-bottom: 50px;
  color: #fff;
}

.search-results .search-results-header h5 {
  float: left;
  margin-bottom: 0;
}

.search-results .search-results-header a#closeSearch {
  float: right;
  vertical-align: middle;
  color: #fff;
  opacity: 0.7;
  transition: all 0.2s ease-in-out;
}

.search-results .search-results-header a#closeSearch:hover {
  opacity: 1;
}

.search-results-show {
  overflow-y: hidden;
}

.search-results-show .search-results {
  visibility: visible;
  opacity: 1;
}

.search-result-list {
  list-style-type: none;
  padding: 0 49.5px;
}

.search-result-list li {
  display: block;
  clear: both;
  margin-bottom: 40px;
  overflow: hidden;
}

.search-result-list.user-search li img {
  width: 50px;
  border-radius: 5px;
  float: left;
}

.search-result-list.user-search li p {
  display: block;
  float: left;
  padding: 5px 15px;
  width: calc(100% - 50px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.search-result-list span.search-input-value {
  font-weight: 700;
}

.search-result-list.article-search li p {
  margin-bottom: 5px;
  padding-bottom: 15px;
}

.search-result-list.article-search li span:not(.search-input-value) {
  opacity: 0.4;
}

.search-result-list.social-search li .social-search-icon {
  display: inline-block;
  margin: 0 10px 0 0;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background: #000;
  color: #fff;
  border-radius: 5px;
}

.search-result-list.social-search li .social-search-icon.facebook-icon-bg {
  background: #3360ff;
}

.search-result-list.social-search li .social-search-icon.twitter-icon-bg {
  background: #1da1f2;
}

.search-result-list.social-search li .social-search-icon.google-icon-bg {
  background: #0f9d58;
}

.search-result-list.social-search li .social-search-text {
  display: inline-block;
  padding: 5px;
}

.search-result-list.social-search li .social-search-text p {
  line-height: 40px;
}

.css-13cymwt-control {
  background-color: #1f1f2b !important;
  border-color: #252533 !important;
  color: #fff !important;
  font-size: 15px !important;
}

.css-1nmdiq5-menu {
  background-color: #1f1f2b !important;
  border-color: #252533 !important;
  color: #fff !important;
  font-size: 15px !important;
}

.css-1dimb5e-singleValue {
  color: #fff !important;
}

.css-t3ipsp-control {
  background-color: #1f1f2b !important;
  border-color: #252533 !important;
  color: #fff !important;
  font-size: 15px !important;
  box-shadow: none !important;
}

.css-t3ipsp-control:hover {
  background-color: #181821 !important;
  color: #000 !important;
  border-color: #252533 !important;
}

.css-166bipr-Input {
  color: #fff !important;
  font-size: 15px !important;
}

.css-1nmdiqs-menu:hover {
  background-color: #fff !important;
  color: #000 !important;
}

.css-1cfo1cf {
  color: #fff !important;
}

@media (max-width: 1350px) {
  .page-header .navbar #navbarNav {
    flex: 0 1;
    margin-right: 15px;
  }

  .page-header .navbar .logo {
    flex: 0 1 !important;
  }

  .page-header .navbar #navbarNav .navbar-nav li a {
    display: none;
  }

  .page-header .navbar a#sidebar-toggle {
    display: block;
    transform: rotate(-180deg);
  }

  body.sidebar-hidden .page-header .navbar a#sidebar-toggle {
    transform: rotate(0);
  }

  body:not(.sidebar-hidden) .page-sidebar {
    transform: scale(0, 1);
    z-index: 999;
  }

  body.sidebar-hidden .page-sidebar {
    transform: scale(1, 1);
  }

  .page-header {
    width: calc(100% - 56px);
    padding: 0;
  }

  .page-content {
    margin-left: 0;
    padding-left: 0;
    padding-right: 0;
  }

  .search-results {
    left: 0;
    right: 0;
  }

  body.sidebar-hidden .page-content {
    transform: translateX(260px);
  }

  body.sidebar-hidden .page-content {
    margin-left: 0;
  }

  body.sidebar-hidden .page-header {
    width: calc(100% - 56px);
  }

  .page-footer {
    margin: 0 30px;
    width: calc(100% - 60px);
  }
}

@media (max-width: 700px) {
  .activity-sidebar {
    width: 100%;
  }
}

@media (max-width: 1200px) {
  .profile-header {
    margin-top: -60px;
  }

  .profile-cover {
    height: 200px;
  }

  .profile-img {
    display: block;
    float: none !important;
  }

  .profile-img img {
    margin: 0 auto;
    display: inherit;
    width: 100px !important;
    height: 100px !important;
    border-radius: 100px !important;
  }

  .profile-name {
    display: block;
    float: none !important;
    text-align: center;
    margin: 0 !important;
  }

  .profile-name h3 {
    color: #fff !important;
  }

  .profile-header .profile-header-menu {
    display: block;
    float: none;
    margin: 0;
    text-align: center;
  }

  .profile-header .profile-header-menu ul li {
    display: block;
    padding: 0;
    width: calc(100% / 6);
    text-align: center;
  }

  .profile-header .profile-header-menu ul li a {
    padding: 10px;
    text-align: center;
    height: auto !important;
  }

  .profile-header .profile-header-menu ul li a.active,
  .profile-header .profile-header-menu ul li a:hover {
    color: #fff;
  }

  .mail-actions {
    display: none;
  }

  .mail-title {
    max-width: 100%;
  }
}

@media (max-width: 992px) {
  .error-image {
    display: none;
  }

  .error-info {
    width: 100%;
    text-align: center;
  }

  .header-search {
    width: 100%;
    margin: 0;
    height: 70px;
    display: block !important;
    position: absolute;
    top: 0;
    z-index: 99999;
    left: 0;
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease-in-out;
  }

  .header-search .close-search {
    display: block;
  }

  .header-search .form-control {
    height: 70px;
  }

  .header-search::before {
    height: 70px;
    line-height: 70px;
  }

  .search-show .header-search {
    transform: none;
    visibility: visible;
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/main.min.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;EAGE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,MAAM;EACN,QAAQ;EACR,YAAY;EAIZ,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,aAAa;EAIb,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,UAAQ;AACV;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EAId,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;;;;;;EAOE,UAAU;EACV,WAAW;EACX,WAAW;EACX,QAAQ;EACR,kBAAkB;EAElB,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,UAAQ;EACR,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAQ;EACR,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAIlB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EAIX,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EAId,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,0CAA0C;EAC1C,MAAM;EACN,YAAY;EAIZ,gCAAgC;EAChC,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EAId,gCAAgC;EAChC,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAIlB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EAIf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAIlB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,kCAAkC;IAClC,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,6BAA6B;IAC7B,6BAA6B;IAC7B,QAAQ;IACR,cAAc;IACd,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;;;;;;IAME,aAAa;EACf;;EAEA;IACE,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,4CAA4C;IAC5C,oDAAoD;IACpD,iDAAiD;IACjD,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IAInB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,gCAAgC;IAChC,+BAA+B;IAC/B,oCAAoC;IACpC,iCAAiC;IACjC,WAAW;EACb;;EAEA;;IAEE,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;IAIzB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAIlB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAI/B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,mCAAmC;AACrC;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,mCAAmC;AACrC;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,mCAAmC;AACrC;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,mCAAmC;AACrC;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,mCAAmC;AACrC;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EAEzB,6CAA6C;EAC7C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EAIE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;EAKE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;;;;;EAKE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EAIrB,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,2EAA0D;EAC1D,wBAAwB;AAC1B;;AAEA;EACE,2EAA0D;EAC1D,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAIlB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EAIE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EAId,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,2EAAsE;EACtE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAIhB,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,mCAAmC;AACrC;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EAIR,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,4BAA4B;EAC5B,cAAc;EAId,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,cAAc;EACd,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EAInB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,YAAY;EAIZ,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,oBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,wBAAwB;IACxB,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,UAAU;IACV,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;IACN,cAAc;IACd,OAAO;IACP,4BAA4B;IAC5B,UAAU;IACV,kBAAkB;IAIlB,gCAAgC;EAClC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":["body,\r\nhtml {\r\n  font-size: 14px;\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: 100vh;\r\n}\r\n\r\nhtml {\r\n  overflow-x: hidden;\r\n}\r\n\r\nbody {\r\n  background-color: #181821 !important;\r\n  font-weight: 400;\r\n  color: #9a9cab !important;\r\n  line-height: 1.6;\r\n}\r\n\r\na {\r\n  color: #83d8ae;\r\n  text-decoration: none;\r\n}\r\n\r\na:hover {\r\n  color: #e8538f !important;\r\n}\r\n\r\np {\r\n  line-height: 1.6;\r\n}\r\n\r\nsmall {\r\n  font-size: 80%;\r\n  font-weight: 400;\r\n}\r\n\r\nmenu {\r\n  padding-left: 0;\r\n}\r\n\r\na,\r\nbody,\r\nspan,\r\ntext {\r\n  font-family: Poppins, sans-serif;\r\n}\r\n\r\na:active,\r\na:focus,\r\na:hover {\r\n  outline: 0 !important;\r\n  text-decoration: none !important;\r\n}\r\n\r\n.bold,\r\nb,\r\nstrong {\r\n  font-weight: 600;\r\n}\r\n\r\ndt {\r\n  font-weight: 500;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  font-family: Poppins, sans-serif;\r\n}\r\n\r\n.divider {\r\n  display: block;\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 1px;\r\n  background: #e8e8e8;\r\n  margin: 30px 0;\r\n}\r\n\r\n.no-s {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n.no-m {\r\n  margin: 0;\r\n}\r\n\r\n.no-p {\r\n  padding: 0;\r\n}\r\n\r\n.m {\r\n  margin: 15px;\r\n}\r\n\r\n.m-t-xxs {\r\n  margin-top: 5px;\r\n}\r\n\r\n.m-r-xxs {\r\n  margin-right: 5px;\r\n}\r\n\r\n.m-b-xxs {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.m-l-xxs {\r\n  margin-left: 5px;\r\n}\r\n\r\n.m-t-xs {\r\n  margin-top: 10px;\r\n}\r\n\r\n.m-r-xs {\r\n  margin-right: 10px;\r\n}\r\n\r\n.m-b-xs {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.m-l-xs {\r\n  margin-left: 10px;\r\n}\r\n\r\n.m-t-sm {\r\n  margin-top: 15px;\r\n}\r\n\r\n.m-r-sm {\r\n  margin-right: 15px;\r\n}\r\n\r\n.m-b-sm {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.m-l-sm {\r\n  margin-left: 15px;\r\n}\r\n\r\n.m-t-md {\r\n  margin-top: 20px;\r\n}\r\n\r\n.m-r-md {\r\n  margin-right: 20px;\r\n}\r\n\r\n.m-b-md {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.m-l-md {\r\n  margin-left: 20px;\r\n}\r\n\r\n.m-t-lg {\r\n  margin-top: 25px;\r\n}\r\n\r\n.m-r-lg {\r\n  margin-right: 25px;\r\n}\r\n\r\n.m-b-lg {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.m-l-lg {\r\n  margin-left: 25px;\r\n}\r\n\r\n.m-t-xxl {\r\n  margin-top: 30px;\r\n}\r\n\r\n.m-r-xxl {\r\n  margin-right: 30px;\r\n}\r\n\r\n.m-b-xxl {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.m-l-xxl {\r\n  margin-left: 30px;\r\n}\r\n\r\n.m-t-n-xxs {\r\n  margin-top: -5px;\r\n}\r\n\r\n.m-r-n-xxs {\r\n  margin-right: -5px;\r\n}\r\n\r\n.m-b-n-xxs {\r\n  margin-bottom: -5px;\r\n}\r\n\r\n.m-l-n-xxs {\r\n  margin-left: -5px;\r\n}\r\n\r\n.m-t-n-xs {\r\n  margin-top: -10px;\r\n}\r\n\r\n.m-r-n-xs {\r\n  margin-right: -10px;\r\n}\r\n\r\n.m-b-n-xs {\r\n  margin-bottom: -10px;\r\n}\r\n\r\n.m-l-n-xs {\r\n  margin-left: -10px;\r\n}\r\n\r\n.m-t-n-sm {\r\n  margin-top: -15px;\r\n}\r\n\r\n.m-r-n-sm {\r\n  margin-right: -15px;\r\n}\r\n\r\n.m-b-n-sm {\r\n  margin-bottom: -15px;\r\n}\r\n\r\n.m-l-n-sm {\r\n  margin-left: -15px;\r\n}\r\n\r\n.m-t-n-md {\r\n  margin-top: -20px;\r\n}\r\n\r\n.m-r-n-md {\r\n  margin-right: -20px;\r\n}\r\n\r\n.m-b-n-md {\r\n  margin-bottom: -20px;\r\n}\r\n\r\n.m-l-n-md {\r\n  margin-left: -20px;\r\n}\r\n\r\n.m-t-n-lg {\r\n  margin-top: -25px;\r\n}\r\n\r\n.m-r-n-lg {\r\n  margin-right: -25px;\r\n}\r\n\r\n.m-b-n-lg {\r\n  margin-bottom: -25px;\r\n}\r\n\r\n.m-l-n-lg {\r\n  margin-left: -25px;\r\n}\r\n\r\n.m-t-n-xxl {\r\n  margin-top: -30px;\r\n}\r\n\r\n.m-r-n-xxl {\r\n  margin-right: -30px;\r\n}\r\n\r\n.m-b-n-xxl {\r\n  margin-bottom: -30px;\r\n}\r\n\r\n.m-l-n-xxl {\r\n  margin-left: -30px;\r\n}\r\n\r\n.p {\r\n  padding: 15px;\r\n}\r\n\r\n.p-h-xxs {\r\n  padding-left: 5px;\r\n  padding-right: 5px;\r\n}\r\n\r\n.p-h-xs {\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n}\r\n\r\n.p-h-sm {\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n}\r\n\r\n.no-p-h {\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n.no-p-v {\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.p-h-md {\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n.p-h-lg {\r\n  padding-left: 25px;\r\n  padding-right: 25px;\r\n}\r\n\r\n.p-h-xxl {\r\n  padding-left: 30px;\r\n  padding-right: 30px;\r\n}\r\n\r\n.p-v-xxs {\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.p-v-xs {\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.p-v-sm {\r\n  padding-top: 15px;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.p-v-md {\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.p-v-lg {\r\n  padding-top: 25px;\r\n  padding-bottom: 25px;\r\n}\r\n\r\n.p-v-xxl {\r\n  padding-top: 30px;\r\n  padding-bottom: 30px;\r\n}\r\n\r\n.full-height {\r\n  height: 100% !important;\r\n}\r\n\r\n.full-width {\r\n  width: 100% !important;\r\n}\r\n\r\n.w-xxs {\r\n  width: 50px;\r\n}\r\n\r\n.w-xs {\r\n  width: 90px;\r\n}\r\n\r\n.w-sm {\r\n  width: 140px;\r\n}\r\n\r\n.w {\r\n  width: 200px;\r\n}\r\n\r\n.w-md {\r\n  width: 240px;\r\n}\r\n\r\n.w-lg {\r\n  width: 280px;\r\n}\r\n\r\n.w-xl {\r\n  width: 330px;\r\n}\r\n\r\n.w-xxl {\r\n  width: 370px;\r\n}\r\n\r\n.w-auto {\r\n  width: auto;\r\n}\r\n\r\n.h-auto {\r\n  height: auto;\r\n}\r\n\r\n.no-b {\r\n  border: 0 !important;\r\n}\r\n\r\n.b {\r\n  border: 1px solid #eaecf3;\r\n}\r\n\r\n.b-t {\r\n  border-top: 1px solid #eaecf3;\r\n}\r\n\r\n.b-r {\r\n  border-right: 1px solid #eaecf3;\r\n}\r\n\r\n.b-b {\r\n  border-bottom: 1px solid #eaecf3;\r\n}\r\n\r\n.b-l {\r\n  border-left: 1px solid #eaecf3;\r\n}\r\n\r\n.b-default {\r\n  border-color: #eaecf3;\r\n}\r\n\r\n.b-primary {\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.b-info {\r\n  border-color: #9c6efc;\r\n}\r\n\r\n.b-success {\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.b-warning {\r\n  border-color: #ffaf0f;\r\n}\r\n\r\n.b-danger {\r\n  border-color: #ee6e83;\r\n}\r\n\r\n.b-2 {\r\n  border-width: 2px;\r\n}\r\n\r\n.b-3 {\r\n  border-width: 3px;\r\n}\r\n\r\n.b-4 {\r\n  border-width: 4px;\r\n}\r\n\r\n.b-n-t {\r\n  border-top: 0;\r\n}\r\n\r\n.b-n-r {\r\n  border-right: 0;\r\n}\r\n\r\n.b-n-b {\r\n  border-bottom: 0;\r\n}\r\n\r\n.b-n-l {\r\n  border-left: 0;\r\n}\r\n\r\n.no-r {\r\n  border-radius: 0 !important;\r\n}\r\n\r\n.r {\r\n  border-radius: 15px;\r\n}\r\n\r\n.r-t-l {\r\n  border-top-left-radius: 15px;\r\n}\r\n\r\n.r-t-r {\r\n  border-top-right-radius: 15px;\r\n}\r\n\r\n.r-b-l {\r\n  border-bottom-left-radius: 15px;\r\n}\r\n\r\n.r-b-r {\r\n  border-bottom-right-radius: 15px;\r\n}\r\n\r\n.no-r-t-l {\r\n  border-top-left-radius: 0 !important;\r\n}\r\n\r\n.no-r-t-r {\r\n  border-top-right-radius: 0 !important;\r\n}\r\n\r\n.no-r-b-l {\r\n  border-bottom-left-radius: 0 !important;\r\n}\r\n\r\n.no-r-b-r {\r\n  border-bottom-right-radius: 0 !important;\r\n}\r\n\r\n.bg-primary {\r\n  background-color: #86c1ed !important;\r\n}\r\n\r\n.bg-secondary {\r\n  background-color: #e9f0f2 !important;\r\n}\r\n\r\n.bg-success {\r\n  background-color: #83d8ae !important;\r\n}\r\n\r\n.bg-danger {\r\n  background-color: #e8538f !important;\r\n}\r\n\r\n.bg-warning {\r\n  background-color: #fad292 !important;\r\n}\r\n\r\n.bg-info {\r\n  background-color: #ada6f2 !important;\r\n}\r\n\r\n.bg-light {\r\n  background-color: #f3f6f9 !important;\r\n}\r\n\r\n.bg-dark {\r\n  background-color: #242e44 !important;\r\n}\r\n\r\n.text-muted {\r\n  color: #7d7f8c !important;\r\n}\r\n\r\n.text-white {\r\n  color: #fff;\r\n}\r\n\r\n.text-primary {\r\n  color: #86c1ed !important;\r\n}\r\n\r\n.text-secondary {\r\n  color: #5b6875 !important;\r\n}\r\n\r\n.text-success {\r\n  color: #83d8ae !important;\r\n}\r\n\r\n.text-danger {\r\n  color: #e8538f !important;\r\n}\r\n\r\n.text-warning {\r\n  color: #fad292 !important;\r\n}\r\n\r\n.text-info {\r\n  color: #ada6f2 !important;\r\n}\r\n\r\n.text-light {\r\n  color: #f3f6f9 !important;\r\n}\r\n\r\n.text-dark {\r\n  color: #5b5b5b !important;\r\n}\r\n\r\n.page-container {\r\n  position: relative;\r\n  display: block;\r\n}\r\n\r\n.page-header {\r\n  position: absolute;\r\n  width: calc(100% - 280px);\r\n  margin: 0 30px;\r\n  top: 0;\r\n  right: 0;\r\n  z-index: 999;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.header-title h5 {\r\n  margin: 0;\r\n  line-height: 41px;\r\n  color: #fff;\r\n}\r\n\r\n.header-search {\r\n  background-color: #181821;\r\n  border-radius: 10px;\r\n}\r\n\r\n.header-search:before {\r\n  display: block;\r\n  content: \"search\";\r\n  font-family: \"Material Icons\";\r\n  font-size: 20px;\r\n  height: 42px;\r\n  line-height: 42px;\r\n  padding: 0 15px;\r\n  position: absolute;\r\n  z-index: 99;\r\n  color: #9a9cab;\r\n}\r\n\r\n.header-search .form-control {\r\n  margin-left: 30px;\r\n  border: none;\r\n  background-color: #181821;\r\n  width: calc(100% - 30px);\r\n  color: #fff;\r\n}\r\n\r\n.header-search .form-control::placeholder {\r\n  color: #9a9cab;\r\n}\r\n\r\n.header-search .form-control:focus {\r\n  outline: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.header-search .close-search {\r\n  display: none;\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #9a9cab;\r\n}\r\n\r\n.header-search .close-search svg {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.page-header .navbar {\r\n  padding: 14px 30px;\r\n  display: flex !important;\r\n  border-bottom: 1px solid #262635;\r\n}\r\n\r\n.page-header .navbar .logo {\r\n  display: flex !important;\r\n  flex: 2;\r\n}\r\n\r\n.page-header .navbar #activity-sidebar-toggle {\r\n  background: #1f1f2b;\r\n  line-height: 22px;\r\n  border-radius: 5px;\r\n  min-width: 40px;\r\n  text-align: center;\r\n  font-weight: 700;\r\n  box-shadow: 0 1px 3px 0 rgb(54 74 99 / 5%);\r\n}\r\n\r\n.page-header .navbar #activity-sidebar-toggle svg {\r\n  color: #fff;\r\n  width: 18px !important;\r\n  height: 18px !important;\r\n}\r\n\r\n.page-header .navbar a#sidebar-toggle {\r\n  padding: 9px 0;\r\n  margin-right: 20px;\r\n  float: left;\r\n  transform: rotate(0);\r\n  display: none;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.page-header .navbar a#sidebar-toggle:hover {\r\n  background: 0 0;\r\n}\r\n\r\n.page-header .navbar #headerNav,\r\n.page-header .navbar #navbarNav {\r\n  display: flex !important;\r\n  flex: 10;\r\n}\r\n\r\n.page-header .navbar #headerNav .navbar-nav,\r\n.page-header .navbar #navbarNav .navbar-nav {\r\n  flex-direction: row !important;\r\n}\r\n\r\n.page-header #sidebar-toggle svg {\r\n  color: #9a9cab;\r\n  width: 22px;\r\n  height: 22px;\r\n}\r\n\r\n.page-header .navbar #headerNav > ul > li > a {\r\n  padding: 9px 0;\r\n  margin: 0 7px;\r\n  color: #9a9cab;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.page-header .navbar #headerNav > ul > li > a svg {\r\n  line-height: 22px;\r\n  vertical-align: middle;\r\n  width: 21px;\r\n  height: 21px;\r\n}\r\n\r\n.page-header .navbar #headerNav > ul > li > a.notifications-dropdown {\r\n  padding: 9px 15px;\r\n  background: #1f1f2b;\r\n  color: #fff;\r\n  line-height: 22px;\r\n  border-radius: 5px;\r\n  min-width: 40px;\r\n  text-align: center;\r\n  font-weight: 700;\r\n  box-shadow: 0 1px 3px 0 rgb(54 74 99 / 5%);\r\n}\r\n\r\n.page-header\r\n  .navbar\r\n  #headerNav\r\n  > ul\r\n  > li\r\n  > a.notifications-dropdown\r\n  .spinner-grow {\r\n  width: 8px;\r\n  height: 8px;\r\n  right: 16px;\r\n  top: 9px;\r\n  position: absolute;\r\n  -webkit-animation: 2.4s linear infinite spinner-grow;\r\n  animation: 2.4s linear infinite spinner-grow;\r\n}\r\n\r\n.page-header .navbar #headerNav > ul > li > a.profile-dropdown {\r\n  padding: 0;\r\n  margin-right: 0;\r\n}\r\n\r\n.page-header .navbar #headerNav > ul > li > a img {\r\n  width: 40px;\r\n  box-shadow: 0 1px 3px 0 rgb(54 74 99 / 5%);\r\n  border-radius: 5px;\r\n}\r\n\r\n.page-header .navbar .navbar-nav {\r\n  flex: 10;\r\n  padding: 0;\r\n}\r\n\r\n.navbar-nav .activity-trigger svg {\r\n  color: #9a9cab;\r\n}\r\n\r\n.page-header #headerNav {\r\n  flex: 10;\r\n  align-items: flex-end;\r\n  flex-direction: column;\r\n}\r\n\r\n.page-header .header-notif {\r\n  padding: 13px 26px;\r\n  -webkit-transition: all 0.1s ease-in-out;\r\n  -moz-transition: all 0.1s ease-in-out;\r\n  -o-transition: all 0.1s ease-in-out;\r\n  transition: all 0.1s ease-in-out;\r\n}\r\n\r\n.page-header .header-notif:hover .notif-text {\r\n  color: #fff;\r\n  -webkit-transition: all 0.1s ease-in-out;\r\n  -moz-transition: all 0.1s ease-in-out;\r\n  -o-transition: all 0.1s ease-in-out;\r\n  transition: all 0.1s ease-in-out;\r\n}\r\n\r\n.page-header .header-notif .notif-image {\r\n  float: left;\r\n  margin-right: 10px;\r\n  margin-top: 3px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.page-header .header-notif .notif-image span {\r\n  width: 40px;\r\n  height: 40px;\r\n  display: block;\r\n  line-height: 40px;\r\n  text-align: center;\r\n  border-radius: 5px;\r\n  display: inline-block;\r\n}\r\n\r\n.page-header .header-notif .notif-image img {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.page-header .header-notif .notif-text {\r\n  width: 223px;\r\n  display: block;\r\n  padding: 0 5px;\r\n  display: inline-block;\r\n  color: #9a9cab;\r\n  font-weight: 400;\r\n}\r\n\r\n.page-header .header-notif .notif-text .bold-notif-text {\r\n  font-weight: 500;\r\n}\r\n\r\n.page-header .header-notif .notif-text p {\r\n  margin: 0;\r\n}\r\n\r\n.page-header .header-notif .notif-text small {\r\n  opacity: 0.7;\r\n}\r\n\r\n.profile-drop-menu a span {\r\n  margin-left: 25px;\r\n}\r\n\r\n.search-drop-menu {\r\n  width: 340px;\r\n}\r\n\r\n.notif-drop-menu {\r\n  width: 340px;\r\n  max-height: 420px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.notif-drop-menu .dropdown-header {\r\n  margin-bottom: 5px;\r\n  font-size: 14px;\r\n}\r\n\r\n.profile-drop-menu a svg {\r\n  margin-right: 10px;\r\n  width: 19px;\r\n  height: 19px;\r\n}\r\n\r\n.navbar-nav .dropdown-menu {\r\n  position: absolute !important;\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  margin-top: 30px;\r\n  display: block;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.navbar-nav .dropdown-menu.show {\r\n  margin-top: 20px;\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n.slimScrollBar {\r\n  background: rgba(0, 0, 0, 0.2) !important;\r\n  border-radius: 4px !important;\r\n}\r\n\r\n.page-sidebar {\r\n  position: fixed;\r\n  height: 100%;\r\n  z-index: 9999;\r\n  left: 0;\r\n  background: #1f1f2b;\r\n  box-shadow: 0 1px 3px 0 rgb(54 74 99 / 5%);\r\n  top: 0;\r\n  width: 280px;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n  transform: scale(1, 1);\r\n  transform-origin: left;\r\n  /* overflow-x: scroll; */\r\n  /* overflow: visible; */\r\n}\r\n\r\n.page-sidebar .ps__rail-y {\r\n  margin-top: 8px !important;\r\n  margin-bottom: 8px !important;\r\n  background-color: transparent !important;\r\n}\r\n\r\n.page-sidebar .accordion-menu {\r\n  margin-top: 20px;\r\n  height: calc(100% - 141px) !important;\r\n  padding: 10px 15px;\r\n}\r\n\r\n.page-sidebar .accordion-menu > li > a {\r\n  display: block;\r\n  color: #9a9cab;\r\n  -webkit-transition: all 0.1s ease-in-out;\r\n  -moz-transition: all 0.1s ease-in-out;\r\n  -o-transition: all 0.1s ease-in-out;\r\n  transition: all 0.1s ease-in-out;\r\n  line-height: 45px;\r\n  padding: 5px;\r\n  text-decoration: none;\r\n}\r\n\r\n.page-sidebar .accordion-menu > li.active-page > a {\r\n  color: #83d8ae;\r\n  font-weight: 500;\r\n}\r\n\r\n.page-sidebar .accordion-menu > li.active-page > a > svg {\r\n  color: #83d8ae !important;\r\n}\r\n\r\n.page-sidebar .accordion-menu > li.active-page ul li a.active {\r\n  color: #fff;\r\n}\r\n\r\n.page-sidebar .accordion-menu > li > a:hover svg {\r\n  margin-left: 5px;\r\n}\r\n\r\n.page-sidebar .accordion-menu > li > a > svg {\r\n  width: 21px;\r\n  height: 21px;\r\n  line-height: 40px;\r\n  text-align: center;\r\n  vertical-align: text-top;\r\n  color: #9a9cab;\r\n  margin-right: 15px;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.page-sidebar .accordion-menu li.sidebar-title {\r\n  font-weight: 500;\r\n  padding: 10px 15px;\r\n  font-size: 0.875rem;\r\n  color: #6c757d;\r\n  opacity: 0.8;\r\n}\r\n\r\n.page-sidebar .accordion-menu li a .dropdown-icon {\r\n  float: right;\r\n  vertical-align: middle;\r\n  line-height: 44px;\r\n  font-size: 10px;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.page-sidebar .accordion-menu li.open > a > .dropdown-icon {\r\n  visibility: visible;\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.page-sidebar .accordion-menu li ul {\r\n  padding: 5px 0;\r\n  list-style: none;\r\n}\r\n\r\n.page-sidebar .accordion-menu li ul li a {\r\n  color: #9a9cab;\r\n  display: block;\r\n  padding: 5px 15px;\r\n  font-size: 14px;\r\n  position: relative;\r\n  -webkit-transition: all 0.15s ease-in-out;\r\n  -moz-transition: all 0.15s ease-in-out;\r\n  -o-transition: all 0.15s ease-in-out;\r\n  transition: all 0.15s ease-in-out;\r\n  text-decoration: none;\r\n}\r\n\r\n.page-sidebar .accordion-menu li ul li a:hover {\r\n  margin-left: 5px;\r\n}\r\n\r\n.page-sidebar .accordion-menu li ul li a i {\r\n  font-size: 10px;\r\n  padding-right: 21px;\r\n  padding-left: 6px;\r\n}\r\n\r\n.page-sidebar .logo {\r\n  margin-right: 0;\r\n  width: auto;\r\n  height: 30px;\r\n  margin: 18px auto;\r\n  display: block;\r\n  text-align: center;\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n}\r\n\r\n@media (min-width: 1350px) {\r\n  .page-sidebar-collapsed .page-sidebar {\r\n    width: 80px;\r\n    /* overflow: visible !important; */\r\n    overflow-x: scroll !important;\r\n    border-radius: 0;\r\n  }\r\n\r\n  .page-sidebar-collapsed .logo {\r\n    font-size: 0;\r\n  }\r\n\r\n  .page-sidebar-collapsed .logo::first-letter {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-content {\r\n    margin-left: 80px;\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-header {\r\n    width: calc(100% - 160px);\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-sidebar .accordion-menu {\r\n    padding: 0;\r\n    overflow: visible;\r\n    position: absolute !important;\r\n    /* height: auto !important; */\r\n    top: 50%;\r\n    /* top: 50%; */\r\n    transform: translateY(-50%);\r\n    margin-top: 0;\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a {\r\n    font-size: 0;\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a {\r\n    text-align: center;\r\n    padding: 8px;\r\n    width: 80px;\r\n  }\r\n\r\n  .page-sidebar-collapsed\r\n    .page-sidebar\r\n    .accordion-menu\r\n    > li\r\n    > a\r\n    > .dropdown-icon {\r\n    display: none;\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a > svg {\r\n    margin: 0;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-sidebar .accordion-menu > li {\r\n    position: relative;\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a + ul {\r\n    display: block !important;\r\n    position: absolute;\r\n    margin-left: 0;\r\n    top: -15px;\r\n    left: 110px;\r\n    padding: 20px 0;\r\n    background: #1f1f2b;\r\n    box-shadow: 0 0 11px 1px rgba(0, 0, 0, 0.05);\r\n    -webkit-box-shadow: 0 0 11px 1px rgba(0, 0, 0, 0.05);\r\n    -moz-box-shadow: 0 0 11px 1px rgba(0, 0, 0, 0.05);\r\n    min-width: 200px;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    border-radius: 15px;\r\n    -webkit-transition: all 0.2s ease-in-out;\r\n    -moz-transition: all 0.2s ease-in-out;\r\n    -o-transition: all 0.2s ease-in-out;\r\n    transition: all 0.2s ease-in-out;\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a + ul::after {\r\n    position: absolute;\r\n    top: 40px;\r\n    left: -7px;\r\n    right: auto;\r\n    display: inline-block !important;\r\n    border-right: 7px solid #1f1f2b;\r\n    border-bottom: 7px solid transparent;\r\n    border-top: 7px solid transparent;\r\n    content: \"\";\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-sidebar .accordion-menu > li:hover > ul,\r\n  .page-sidebar-collapsed .page-sidebar .accordion-menu > li > a:hover + ul {\r\n    height: auto;\r\n    visibility: visible;\r\n    opacity: 1;\r\n    left: 120px;\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-sidebar .accordion-menu > li:hover {\r\n    width: calc(100% + 30px);\r\n  }\r\n\r\n  .page-sidebar-collapsed .page-sidebar .accordion-menu > li:hover > a > svg {\r\n    color: #83d8ae;\r\n  }\r\n\r\n  #sidebar-collapsed-toggle {\r\n    position: fixed;\r\n    bottom: 0;\r\n    width: 100%;\r\n    padding: 21px 0;\r\n    text-align: center;\r\n    transform: rotate(0);\r\n    background-color: #1f1f2b;\r\n    -webkit-transition: all 0.2s ease-in-out;\r\n    -moz-transition: all 0.2s ease-in-out;\r\n    -o-transition: all 0.2s ease-in-out;\r\n    transition: all 0.2s ease-in-out;\r\n  }\r\n\r\n  #sidebar-collapsed-toggle svg {\r\n    width: 22px;\r\n    height: 22px;\r\n    vertical-align: middle;\r\n    font-size: 22px;\r\n    color: #9a9cab;\r\n  }\r\n\r\n  body:not(.page-sidebar-collapsed) #sidebar-collapsed-toggle {\r\n    transform: rotate(180deg);\r\n  }\r\n}\r\n\r\n@media (max-width: 1350px) {\r\n  #sidebar-collapsed-toggle {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.page-content {\r\n  padding: 70px 70px 0 70px;\r\n  margin-left: 220px;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.main-wrapper {\r\n  padding: 30px 10px;\r\n  min-height: calc(100vh - 142px);\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.page-footer {\r\n  margin: 0 -40px;\r\n  width: calc(100% + 80px);\r\n  border-top: 1px solid #262635;\r\n}\r\n\r\n.page-footer a {\r\n  color: #9a9cab;\r\n}\r\n\r\n.page-footer a svg {\r\n  width: 22px;\r\n  height: 22px;\r\n}\r\n\r\n.footer-left {\r\n  margin-right: 5px;\r\n}\r\n\r\n.footer-right {\r\n  margin-left: 5px;\r\n}\r\n\r\n.page-footer .page-footer-item {\r\n  padding: 24px 30px;\r\n  width: 50%;\r\n}\r\n\r\n.page-footer .page-footer-item.page-footer-item-left {\r\n  float: left;\r\n}\r\n\r\n.page-footer .page-footer-item.page-footer-item-right {\r\n  float: right;\r\n  text-align: right;\r\n}\r\n\r\n.popover {\r\n  margin: 20px;\r\n  border: 0;\r\n  border-radius: 10px;\r\n  box-shadow: 0 0 1.25rem rgba(31, 45, 61, 0.08);\r\n  color: #5b5b5b;\r\n  font-family: Poppins, sans-serif !important;\r\n}\r\n\r\n.popover-header {\r\n  padding: 15px 25px 0;\r\n  background: 0 0;\r\n  border-bottom-color: transparent;\r\n  font-size: 14px;\r\n  opacity: 0.7;\r\n  color: #5b5b5b;\r\n}\r\n\r\n.popover-body {\r\n  padding: 15px 25px;\r\n  font-size: 13px;\r\n  color: #5b5b5b;\r\n}\r\n\r\n.popover .arrow:before {\r\n  display: none;\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\r\n.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\r\n.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\r\n.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\r\n.bs-popover-bottom > .popover-arrow::before,\r\n.bs-popover-end > .popover-arrow::before,\r\n.bs-popover-start > .popover-arrow::before,\r\n.bs-popover-top > .popover-arrow::before {\r\n  display: none;\r\n}\r\n\r\n.card {\r\n  margin-bottom: 21px;\r\n  border-radius: 5px;\r\n  border: none;\r\n  background: #1f1f2b;\r\n}\r\n\r\n.card-bg {\r\n  background-color: #1f1f2b;\r\n}\r\n\r\n.card-title {\r\n  font-size: 16px;\r\n  color: #fff;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.card-body {\r\n  padding: 25px;\r\n}\r\n\r\n.card-description {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.card-img,\r\n.card-img-top {\r\n  border-top-left-radius: 5px;\r\n  border-top-right-radius: 5px;\r\n}\r\n\r\n.card-img,\r\n.card-img-bottom {\r\n  border-bottom-left-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n}\r\n\r\n.card-footer,\r\n.card-header {\r\n  border-color: #262635;\r\n}\r\n\r\n.list-group-item {\r\n  background: 0 0;\r\n}\r\n\r\n.list-group-item.disabled,\r\n.list-group-item:disabled {\r\n  background: 0 0;\r\n}\r\n\r\n.list-group-item:first-child {\r\n  border-top-left-radius: 3px;\r\n  border-top-right-radius: 3px;\r\n}\r\n\r\n.list-group-item:last-child {\r\n  border-bottom-left-radius: 3px;\r\n  border-bottom-right-radius: 3px;\r\n}\r\n\r\n.list-group-item {\r\n  padding: 15px 18px;\r\n  border-color: #262635;\r\n}\r\n\r\n.list-group-item.active {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.list-group-item-action:focus,\r\n.list-group-item-action:hover {\r\n  background: 0 0;\r\n  color: #fff;\r\n}\r\n\r\n.list-group-item.active:focus,\r\n.list-group-item.active:hover {\r\n  background: #83d8ae;\r\n}\r\n\r\n.list-group-item-action {\r\n  color: #9a9cab;\r\n}\r\n\r\n.list-group-item-primary {\r\n  color: #fff;\r\n  background-color: #86c1ed;\r\n  font-weight: 500;\r\n}\r\n\r\n.list-group-item-secondary {\r\n  color: #5b6875;\r\n  background-color: #e9f0f2;\r\n  font-weight: 500;\r\n}\r\n\r\n.list-group-item-success {\r\n  color: #fff;\r\n  background-color: #83d8ae;\r\n  font-weight: 500;\r\n}\r\n\r\n.list-group-item-danger {\r\n  color: #fff;\r\n  background-color: #e8538f;\r\n  font-weight: 500;\r\n}\r\n\r\n.list-group-item-warning {\r\n  color: #fff;\r\n  background-color: #fad292;\r\n  font-weight: 500;\r\n}\r\n\r\n.list-group-item-info {\r\n  color: #fff;\r\n  background-color: #ada6f2;\r\n  font-weight: 500;\r\n}\r\n\r\n.list-group-item-light {\r\n  color: #7e8299;\r\n  background-color: #f3f6f9;\r\n  font-weight: 500;\r\n}\r\n\r\n.list-group-item-dark {\r\n  color: #5b5b5b;\r\n  background-color: #d1d3e0;\r\n  font-weight: 500;\r\n}\r\n\r\n.card-header:first-child {\r\n  border-top-left-radius: 15px;\r\n  border-top-right-radius: 15px;\r\n}\r\n\r\n.card-footer:last-child {\r\n  border-bottom-left-radius: 15px;\r\n  border-bottom-right-radius: 15px;\r\n}\r\n\r\n.card-img-overlay {\r\n  border-radius: 5px;\r\n}\r\n\r\n.card.bg-primary .card-header {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.card.bg-primary .card-title {\r\n  color: #fff;\r\n}\r\n\r\n.card.bg-secondary .card-header {\r\n  background-color: #e4e6ef;\r\n  color: #5b5b5b;\r\n}\r\n\r\n.card.bg-secondary .card-body {\r\n  color: #5b5b5b;\r\n}\r\n\r\n.card.bg-success .card-header {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.card.bg-success .card-title {\r\n  color: #fff;\r\n}\r\n\r\n.card.bg-danger .card-header {\r\n  background-color: #e8538f;\r\n  border-color: #e8538f;\r\n}\r\n\r\n.card.bg-danger .card-title {\r\n  color: #fff;\r\n}\r\n\r\n.card.bg-warning .card-header {\r\n  background-color: #f5af47ea;\r\n  border-color: #f5af47ea;\r\n}\r\n\r\n.card.bg-warning .card-title {\r\n  color: #fff;\r\n}\r\n\r\n.card.bg-info .card-header {\r\n  background-color: #9465fcea;\r\n  border-color: #9465fcea;\r\n}\r\n\r\n.card.bg-info .card-title {\r\n  color: #fff;\r\n}\r\n\r\n.card.bg-dark .card-header {\r\n  background-color: #242e44;\r\n  border-color: #242e44;\r\n}\r\n\r\n.card.bg-dark .card-title {\r\n  color: #fff;\r\n}\r\n\r\n.nav-pills .nav-link.active,\r\n.nav-pills .show > .nav-link {\r\n  background-color: #83d8ae;\r\n}\r\n\r\n.nav-pills .nav-link {\r\n  border-radius: 10px;\r\n}\r\n\r\n.nav-tabs .nav-item.show .nav-link,\r\n.nav-tabs .nav-link,\r\n.nav-tabs .nav-link.active {\r\n  border: 0;\r\n}\r\n\r\n.nav-tabs .nav-item.show .nav-link,\r\n.nav-tabs .nav-link.active {\r\n  background: #83d8ae;\r\n  color: #fff;\r\n}\r\n\r\n.toast {\r\n  border-radius: 3px;\r\n  border: none;\r\n  box-shadow: 0 0 1.25rem rgb(31 45 61 / 8%);\r\n  background-color: rgba(31, 31, 43, 0.7);\r\n}\r\n\r\n.toast-header {\r\n  background-color: rgba(31, 31, 43, 0.95);\r\n  border-top-left-radius: 3px;\r\n  border-top-right-radius: 3px;\r\n  padding: 10px 15px;\r\n  color: #fff;\r\n}\r\n\r\n.toast-body {\r\n  padding: 15px;\r\n}\r\n\r\n.toast-header strong {\r\n  font-weight: 500;\r\n}\r\n\r\n.alert {\r\n  border-radius: 3px;\r\n  padding: 15px 18px;\r\n  font-weight: 500;\r\n}\r\n\r\n.alert-primary {\r\n  background-color: #86c1ed;\r\n  border-color: #86c1ed;\r\n  color: #fff;\r\n}\r\n\r\n.alert-secondary {\r\n  background-color: #e9f0f2;\r\n  border-color: #e9f0f2;\r\n  color: #5b6875;\r\n}\r\n\r\n.alert-success {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n  color: #fff;\r\n}\r\n\r\n.alert-danger {\r\n  background-color: #e8538f;\r\n  border-color: #e8538f;\r\n  color: #fff;\r\n}\r\n\r\n.alert-warning {\r\n  background-color: #fad292;\r\n  border-color: #fad292;\r\n  color: #fff;\r\n}\r\n\r\n.alert-info {\r\n  background-color: #ada6f2;\r\n  border-color: #ada6f2;\r\n  color: #fff;\r\n}\r\n\r\n.alert-light {\r\n  background-color: #f3f6f9;\r\n  border-color: #f3f6f9;\r\n}\r\n\r\n.alert-dark {\r\n  background-color: #d1d3e0;\r\n  border-color: #d1d3e0;\r\n  color: #5b5b5b;\r\n}\r\n\r\n.alert-primary.light-alert {\r\n  background-color: #d9edfc;\r\n  border-color: #b7d4eb;\r\n  color: #5ea5db;\r\n}\r\n\r\n.alert-secondary.light-alert {\r\n  background-color: #e1eaed;\r\n  border-color: #bfd0d6;\r\n  color: #5b6875;\r\n}\r\n\r\n.alert-success.light-alert {\r\n  background-color: #d8f2e5;\r\n  border-color: #b2d4c3;\r\n  color: #2f9c68;\r\n}\r\n\r\n.alert-danger.light-alert {\r\n  background-color: #fce6e6;\r\n  border-color: #dbbdbd;\r\n  color: #c95b59;\r\n}\r\n\r\n.alert-warning.light-alert {\r\n  background-color: #fcf1e1;\r\n  border-color: #e3d5c1;\r\n  color: #b5814a;\r\n}\r\n\r\n.alert-info.light-alert {\r\n  background-color: #e6e3ff;\r\n  border-color: #c0bce0;\r\n  color: #7e78c2;\r\n}\r\n\r\n.alert-light.light-alert {\r\n  background-color: #f3f6f9;\r\n  border-color: #f3f6f9;\r\n}\r\n\r\n.alert-dark.light-alert {\r\n  background-color: #d1d3e0;\r\n  border-color: #242e44;\r\n  color: #383d41;\r\n}\r\n\r\n.icon-list-row {\r\n  margin-top: 30px;\r\n  text-align: center;\r\n}\r\n\r\n.icon-list-row i {\r\n  font-size: 23px;\r\n}\r\n\r\n.icon-state-info {\r\n  color: #83d8ae;\r\n}\r\n\r\n.jstree-default .jstree-clicked,\r\n.jstree-default .jstree-hovered {\r\n  background: #1f1f2b;\r\n}\r\n\r\n.badge {\r\n  font-weight: 500;\r\n  padding: 7px 12px;\r\n  font-size: 12px;\r\n}\r\n\r\n.badge:not(.badge-pill) {\r\n  border-radius: 3px;\r\n}\r\n\r\n.badge.bg-primary {\r\n  background-color: #e3f3ff !important;\r\n  color: #5ea5db;\r\n}\r\n\r\n.badge.bg-secondary {\r\n  background-color: #e9f0f2 !important;\r\n  color: #5b6875 !important;\r\n}\r\n\r\n.badge.bg-success {\r\n  background-color: #e1f7ec !important;\r\n  color: #2f9c68;\r\n}\r\n\r\n.badge.bg-danger {\r\n  background-color: #ffebeb !important;\r\n  color: #c95b59;\r\n}\r\n\r\n.badge.bg-warning {\r\n  background-color: #fff6e8 !important;\r\n  color: #b5814a;\r\n}\r\n\r\n.badge.bg-info {\r\n  background-color: #eae8ff !important;\r\n  color: #7e78c2;\r\n}\r\n\r\n.badge.bg-dark {\r\n  background-color: #d1d3e0 !important;\r\n  color: #5b5b5b;\r\n}\r\n\r\n.badge-icon {\r\n  width: 35px;\r\n  height: 35px;\r\n  padding: 10px;\r\n}\r\n\r\n.btn {\r\n  padding: 8px 20px;\r\n  border-radius: 3px;\r\n  font-weight: 500;\r\n}\r\n\r\n.btn-primary,\r\n.btn-primary.disabled,\r\n.btn-primary:disabled {\r\n  background-color: #86c1ed;\r\n  border-color: #86c1ed;\r\n  color: #fff;\r\n}\r\n\r\n.btn-primary.focus,\r\n.btn-primary:focus,\r\n.btn-primary:hover,\r\n.btn-primary:not(:disabled):not(.disabled).active,\r\n.btn-primary:not(:disabled):not(.disabled):active {\r\n  background-color: #86c1ed;\r\n  border-color: #86c1ed;\r\n  color: #fff;\r\n  box-shadow: 0 3px 18px -8px #86c1ed;\r\n}\r\n\r\n.btn-secondary,\r\n.btn-secondary.disabled,\r\n.btn-secondary:disabled {\r\n  background-color: #e9f0f2;\r\n  border-color: #e9f0f2;\r\n  color: #355261;\r\n}\r\n\r\n.btn-secondary.focus,\r\n.btn-secondary:focus,\r\n.btn-secondary:hover,\r\n.btn-secondary:not(:disabled):not(.disabled).active,\r\n.btn-secondary:not(:disabled):not(.disabled):active {\r\n  background-color: #e9f0f2;\r\n  border-color: #e9f0f2;\r\n  color: #355261;\r\n  box-shadow: 0 3px 18px -8px #e9f0f2;\r\n}\r\n\r\n.btn-success,\r\n.btn-success:disabled,\r\n.btn-sucess.disabled {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n  color: #fff;\r\n}\r\n\r\n.btn-success.focus,\r\n.btn-success:focus,\r\n.btn-success:hover,\r\n.btn-success:not(:disabled):not(.disabled).active,\r\n.btn-success:not(:disabled):not(.disabled):active {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n  color: #fff;\r\n  box-shadow: 0 3px 18px -8px #83d8ae;\r\n}\r\n\r\n.btn-danger,\r\n.btn-danger.disabled,\r\n.btn-danger:disabled {\r\n  background-color: #e8538f;\r\n  border-color: #e8538f;\r\n  color: #fff;\r\n}\r\n\r\n.btn-danger.focus,\r\n.btn-danger:focus,\r\n.btn-danger:hover,\r\n.btn-danger:not(:disabled):not(.disabled).active,\r\n.btn-danger:not(:disabled):not(.disabled):active {\r\n  background-color: #e8538f;\r\n  border-color: #e8538f;\r\n  color: #fff;\r\n  box-shadow: 0 3px 18px -8px #e8538f;\r\n}\r\n\r\n.btn-warning,\r\n.btn-warning.disabled,\r\n.btn-warning:disabled {\r\n  background-color: #fad292;\r\n  border-color: #fad292;\r\n  color: #fff;\r\n}\r\n\r\n.btn-warning.focus,\r\n.btn-warning:focus,\r\n.btn-warning:hover,\r\n.btn-warning:not(:disabled):not(.disabled).active,\r\n.btn-warning:not(:disabled):not(.disabled):active {\r\n  background-color: #fad292;\r\n  border-color: #fad292;\r\n  color: #fff;\r\n  box-shadow: 0 3px 18px -8px #fad292;\r\n}\r\n\r\n.btn-info,\r\n.btn-info.disabled,\r\n.btn-info:disabled {\r\n  background-color: #ada6f2;\r\n  border-color: #ada6f2;\r\n  color: #fff;\r\n}\r\n\r\n.btn-info.focus,\r\n.btn-info:focus,\r\n.btn-info:hover,\r\n.btn-info:not(:disabled):not(.disabled).active,\r\n.btn-info:not(:disabled):not(.disabled):active {\r\n  background-color: #ada6f2;\r\n  border-color: #ada6f2;\r\n  color: #fff;\r\n  box-shadow: 0 3px 18px -8px #ada6f2;\r\n}\r\n\r\n.btn-light,\r\n.btn-light.disabled,\r\n.btn-light:disabled {\r\n  background-color: #f3f6f9;\r\n  border-color: #f3f6f9;\r\n  color: #7e8299;\r\n}\r\n\r\n.btn-light:focus,\r\n.btn-light:hover .btn-light.focus,\r\n.btn-light:not(:disabled):not(.disabled).active,\r\n.btn-light:not(:disabled):not(.disabled):active {\r\n  background-color: #f3f6f9;\r\n  border-color: #f3f6f9;\r\n  color: #7e8299;\r\n  box-shadow: 0 3px 18px -8px #f3f6f9;\r\n}\r\n\r\n.btn-dark,\r\n.btn-dark.disabled,\r\n.btn-dark:disabled {\r\n  background-color: #d1d3e0;\r\n  border-color: #d1d3e0;\r\n  color: #5b5b5b;\r\n}\r\n\r\n.btn-dark.focus,\r\n.btn-dark:focus,\r\n.btn-dark:hover,\r\n.btn-dark:not(:disabled):not(.disabled).active,\r\n.btn-dark:not(:disabled):not(.disabled):active {\r\n  background-color: #d1d3e0;\r\n  border-color: #d1d3e0;\r\n  color: #5b5b5b;\r\n  box-shadow: 0 3px 18px -8px #d1d3e0;\r\n}\r\n\r\n.btn-circle {\r\n  width: 40px;\r\n  height: 40px;\r\n  padding: 0;\r\n  border-radius: 50%;\r\n}\r\n\r\n.btn-link {\r\n  color: #83d8ae;\r\n  text-decoration: none;\r\n  border: none;\r\n}\r\n\r\n.btn-link:hover {\r\n  color: #83d8ae;\r\n  text-decoration: underline;\r\n}\r\n\r\n.btn-outline-primary {\r\n  color: #86c1ed;\r\n  border-color: #86c1ed;\r\n}\r\n\r\n.btn-outline-primary.focus,\r\n.btn-outline-primary:focus,\r\n.btn-outline-primary:hover,\r\n.btn-outline-primary:not(:disabled):not(.disabled).active,\r\n.btn-outline-primary:not(:disabled):not(.disabled):active {\r\n  color: #fff;\r\n  border-color: #86c1ed;\r\n  background-color: #86c1ed;\r\n  box-shadow: 0 3px 18px -8px #86c1ed;\r\n}\r\n\r\n.btn-outline-secondary {\r\n  color: #e9f0f2;\r\n  border-color: #e9f0f2;\r\n}\r\n\r\n.btn-outline-secondary.focus,\r\n.btn-outline-secondary:focus,\r\n.btn-outline-secondary:hover,\r\n.btn-outline-secondary:not(:disabled):not(.disabled).active,\r\n.btn-outline-secondary:not(:disabled):not(.disabled):active {\r\n  color: #355261;\r\n  border-color: #e9f0f2;\r\n  background-color: #e9f0f2;\r\n  box-shadow: 0 3px 18px -8px #e9f0f2;\r\n}\r\n\r\n.btn-outline-success {\r\n  color: #83d8ae;\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.btn-outline-success.focus,\r\n.btn-outline-success:focus,\r\n.btn-outline-success:hover,\r\n.btn-outline-success:not(:disabled):not(.disabled).active,\r\n.btn-outline-success:not(:disabled):not(.disabled):active {\r\n  color: #fff;\r\n  border-color: #83d8ae;\r\n  background-color: #83d8ae;\r\n  box-shadow: 0 3px 18px -8px #83d8ae;\r\n}\r\n\r\n.btn-outline-danger {\r\n  color: #e8538f;\r\n  border-color: #e8538f;\r\n}\r\n\r\n.btn-outline-danger.focus,\r\n.btn-outline-danger:focus,\r\n.btn-outline-danger:hover,\r\n.btn-outline-danger:not(:disabled):not(.disabled).active,\r\n.btn-outline-danger:not(:disabled):not(.disabled):active {\r\n  color: #fff;\r\n  border-color: #e8538f;\r\n  background-color: #e8538f;\r\n  box-shadow: 0 3px 18px -8px #e8538f;\r\n}\r\n\r\n.btn-outline-warning {\r\n  color: #fad292;\r\n  border-color: #fad292;\r\n}\r\n\r\n.btn-outline-warning.focus,\r\n.btn-outline-warning:focus,\r\n.btn-outline-warning:hover,\r\n.btn-outline-warning:not(:disabled):not(.disabled).active,\r\n.btn-outline-warning:not(:disabled):not(.disabled):active {\r\n  color: #fff;\r\n  border-color: #fad292;\r\n  background-color: #fad292;\r\n  box-shadow: 0 3px 18px -8px #fad292;\r\n}\r\n\r\n.btn-outline-info {\r\n  color: #ada6f2;\r\n  border-color: #ada6f2;\r\n}\r\n\r\n.btn-outline-info.focus,\r\n.btn-outline-info:focus,\r\n.btn-outline-info:hover,\r\n.btn-outline-info:not(:disabled):not(.disabled).active,\r\n.btn-outline-info:not(:disabled):not(.disabled):active {\r\n  color: #fff;\r\n  border-color: #ada6f2;\r\n  background-color: #ada6f2;\r\n  box-shadow: 0 3px 18px -8px #ada6f2;\r\n}\r\n\r\n.btn-outline-dark {\r\n  color: #5b5b5b;\r\n  border-color: #d1d3e0;\r\n}\r\n\r\n.btn-outline-dark.focus,\r\n.btn-outline-dark:focus,\r\n.btn-outline-dark:hover,\r\n.btn-outline-dark:not(:disabled):not(.disabled).active,\r\n.btn-outline-dark:not(:disabled):not(.disabled):active {\r\n  color: #5b5b5b;\r\n  border-color: #d1d3e0;\r\n  background-color: #d1d3e0;\r\n  box-shadow: 0 3px 18px -8px #d1d3e0;\r\n}\r\n\r\nbody.modal-open {\r\n  overflow: visible;\r\n}\r\n\r\n.modal-content {\r\n  border-radius: 3px;\r\n  border: none;\r\n}\r\n\r\n.modal-header {\r\n  padding: 30px;\r\n  border: 0;\r\n  color: #5b5b5b;\r\n}\r\n\r\n.modal-footer {\r\n  padding: 30px;\r\n  border: 0;\r\n}\r\n\r\n.modal-body {\r\n  padding: 0 30px;\r\n  color: #5b5b5b;\r\n}\r\n\r\n.modal-backdrop {\r\n  z-index: 11000;\r\n}\r\n\r\n.modal {\r\n  z-index: 11001;\r\n}\r\n\r\n.dropdown-header {\r\n  color: #fff;\r\n}\r\n\r\n.dropdown-menu {\r\n  background: #1f1f2b;\r\n  border-radius: 5px;\r\n  border: none;\r\n  box-shadow: 0 0 1.25rem rgb(31 45 61 / 5%);\r\n  padding: 15px 0;\r\n  margin: 10px 0;\r\n}\r\n\r\n.dropdown-item {\r\n  color: #9a9cab;\r\n  padding: 9px 26px;\r\n}\r\n\r\n.dropdown-item:hover {\r\n  background: 0 0;\r\n  color: #e85382;\r\n}\r\n\r\n.dropdown-divider {\r\n  border-color: #2b2b3b;\r\n}\r\n\r\n.dropdown-menu-dark {\r\n  background-color: #1f1f2b;\r\n  color: #565673;\r\n}\r\n\r\n.dropdown-menu-dark .dropdown-item {\r\n  color: #9a9cab;\r\n}\r\n\r\n.dropdown-menu-dark .dropdown-item:hover {\r\n  background: 0 0;\r\n  color: #83d8ae;\r\n}\r\n\r\n.dropdown-menu-dark .dropdown-item.active,\r\n.dropdown-menu-dark .dropdown-item:active {\r\n  color: #83d8ae;\r\n  background: 0 0;\r\n}\r\n\r\n.dropdown-item.active,\r\n.dropdown-item:active {\r\n  color: #83d8ae;\r\n  background: 0 0;\r\n}\r\n\r\n.dropdown-header {\r\n  padding: 8px 26px;\r\n}\r\n\r\n.dropdown-menu form {\r\n  padding: 8px 20px;\r\n}\r\n\r\n.page-link {\r\n  color: #9a9cab;\r\n  border-color: #2b2b3b;\r\n  background-color: #1f1f2b;\r\n  padding: 8px 11px;\r\n}\r\n\r\n.page-link:hover {\r\n  opacity: 0.8;\r\n  background-color: #1f1f2b;\r\n  border-color: #2b2b3b;\r\n  color: #9a9cab;\r\n}\r\n\r\n.page-item.disabled .page-link {\r\n  border-color: #2b2b3b;\r\n  background-color: #1f1f2b;\r\n  opacity: 0.8;\r\n}\r\n\r\n.page-item:first-child .page-link {\r\n  border-top-left-radius: 3px;\r\n  border-bottom-left-radius: 3px;\r\n}\r\n\r\n.page-item:last-child .page-link {\r\n  border-top-right-radius: 3px;\r\n  border-bottom-right-radius: 3px;\r\n}\r\n\r\n.page-item.active .page-link {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.progress {\r\n  background-color: #1f1f2b;\r\n  border-radius: 2px;\r\n}\r\n\r\n.progress-bar {\r\n  background-color: #86c1ed;\r\n}\r\n\r\n.accordion-button {\r\n  border: none;\r\n  background-color: #1f1f2b;\r\n  -webkit-box-shadow: 0 0 7px 0 rgba(63, 71, 105, 0.08);\r\n  box-shadow: 0 0 7px 0 rgba(63, 71, 105, 0.08);\r\n  padding: 15px 18px;\r\n  color: #9a9cab;\r\n}\r\n\r\n.accordion-collapse {\r\n  border: none;\r\n}\r\n\r\n.accordion-button:not(.collapsed) {\r\n  background-color: #1f1f2b;\r\n  color: #83d8ae;\r\n}\r\n\r\n.accordion-item:first-of-type .accordion-button {\r\n  border-top-left-radius: 3px;\r\n  border-top-right-radius: 3px;\r\n}\r\n\r\n.accordion-item:last-of-type .accordion-button.collapsed {\r\n  border-bottom-left-radius: 3px;\r\n  border-bottom-right-radius: 3px;\r\n}\r\n\r\n.accordion-flush .accordion-button {\r\n  box-shadow: none;\r\n}\r\n\r\n.accordion-flush .accordion-item .accordion-button {\r\n  background: 0 0;\r\n}\r\n\r\n.form-control {\r\n  border-color: #2d2d3f;\r\n  background: #1f1f2b;\r\n  border-radius: 3px;\r\n  padding: 0.65rem 1rem;\r\n  color: #fff !important;\r\n}\r\n\r\n.form-control:focus {\r\n  border-color: #2d2d3f;\r\n  background: #181821;\r\n}\r\n\r\n.form-control:disabled,\r\n.form-control[readonly],\r\n.form-select:disabled {\r\n  border-color: #2d2d3f;\r\n  background: #181821;\r\n  opacity: 0.8;\r\n}\r\n\r\n.form-control-color {\r\n  padding: 7px;\r\n}\r\n\r\n.form-select {\r\n  border-color: #2d2d3f;\r\n  background: #181821;\r\n  color: #9a9cab;\r\n  border-radius: 3px;\r\n  padding: 0.65rem 1rem;\r\n}\r\n\r\n.form-check-input {\r\n  background: #1f1f2b;\r\n  border: 1px solid #2d2d3f;\r\n}\r\n\r\n.form-check-input:checked {\r\n  background-color: #e8538f;\r\n  border-color: #e8538f;\r\n}\r\n\r\n.input-group-text {\r\n  border-radius: 3px;\r\n  background-color: #181821;\r\n  border-color: #2d2d3f;\r\n  color: #fff;\r\n}\r\n\r\n.form-control.is-valid,\r\n.form-select.is-valid,\r\n.was-validated .form-control:valid,\r\n.was-validated .form-select:valid {\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.form-check-input.is-valid ~ .form-check-label,\r\n.valid-feedback,\r\n.was-validated .form-check-input:valid ~ .form-check-label {\r\n  color: #83d8ae;\r\n}\r\n\r\n.form-check-input.is-valid:checked,\r\n.was-validated .form-check-input:valid:checked {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.form-control.is-invalid,\r\n.form-select.is-invalid,\r\n.was-validated .form-control:invalid,\r\n.was-validated .form-select:invalid {\r\n  border-color: #e8538f;\r\n}\r\n\r\n.invalid-feedback {\r\n  color: #e8538f;\r\n}\r\n\r\n.form-check-input.is-invalid ~ .form-check-label,\r\n.was-validated .form-check-input:invalid ~ .form-check-label {\r\n  color: #e8538f;\r\n}\r\n\r\n.form-check-input.is-invalid,\r\n.was-validated .form-check-input:invalid {\r\n  border-color: #e8538f;\r\n}\r\n\r\n.table {\r\n  color: #9a9cab;\r\n  border-color: #e4e6ef;\r\n}\r\n\r\n.table img {\r\n  margin-right: 10px;\r\n}\r\n\r\n.table-primary {\r\n  --bs-table-bg: #86c1ed;\r\n  --bs-table-striped-bg: #86c1ed;\r\n  --bs-table-striped-color: #000;\r\n  --bs-table-active-bg: #86c1ed;\r\n  --bs-table-active-color: #000;\r\n  --bs-table-hover-bg: #86c1ed;\r\n  --bs-table-hover-color: #000;\r\n  color: #fff;\r\n  border-color: #86c1ed;\r\n}\r\n\r\n.table-secondary {\r\n  --bs-table-bg: #e9f0f2;\r\n  --bs-table-striped-bg: #e9f0f2;\r\n  --bs-table-striped-color: #000;\r\n  --bs-table-active-bg: #e9f0f2;\r\n  --bs-table-active-color: #000;\r\n  --bs-table-hover-bg: #e9f0f2;\r\n  --bs-table-hover-color: #000;\r\n  color: #5b6875;\r\n  border-color: #e9f0f2;\r\n}\r\n\r\n.table-success {\r\n  --bs-table-bg: #83d8ae;\r\n  --bs-table-striped-bg: #83d8ae;\r\n  --bs-table-striped-color: #000;\r\n  --bs-table-active-bg: #83d8ae;\r\n  --bs-table-active-color: #000;\r\n  --bs-table-hover-bg: #83d8ae;\r\n  --bs-table-hover-color: #000;\r\n  color: #fff;\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.table-danger {\r\n  --bs-table-bg: #e8538f;\r\n  --bs-table-striped-bg: #e8538f;\r\n  --bs-table-striped-color: #000;\r\n  --bs-table-active-bg: #e8538f;\r\n  --bs-table-active-color: #000;\r\n  --bs-table-hover-bg: #e8538f;\r\n  --bs-table-hover-color: #000;\r\n  color: #fff;\r\n  border-color: #e8538f;\r\n}\r\n\r\n.table-warning {\r\n  --bs-table-bg: #fad292;\r\n  --bs-table-striped-bg: #fad292;\r\n  --bs-table-striped-color: #000;\r\n  --bs-table-active-bg: #fad292;\r\n  --bs-table-active-color: #000;\r\n  --bs-table-hover-bg: #fad292;\r\n  --bs-table-hover-color: #000;\r\n  color: #fff;\r\n  border-color: #fad292;\r\n}\r\n\r\n.table-info {\r\n  --bs-table-bg: #ada6f2;\r\n  --bs-table-striped-bg: #ada6f2;\r\n  --bs-table-striped-color: #000;\r\n  --bs-table-active-bg: #ada6f2;\r\n  --bs-table-active-color: #000;\r\n  --bs-table-hover-bg: #ada6f2;\r\n  --bs-table-hover-color: #000;\r\n  color: #fff;\r\n  border-color: #ada6f2;\r\n}\r\n\r\n.table-light {\r\n  --bs-table-bg: #f3f6f9;\r\n  --bs-table-striped-bg: #f3f6f9;\r\n  --bs-table-striped-color: #000;\r\n  --bs-table-active-bg: #f3f6f9;\r\n  --bs-table-active-color: #000;\r\n  --bs-table-hover-bg: #f3f6f9;\r\n  --bs-table-hover-color: #000;\r\n  color: #5b5b5b;\r\n  border-color: #f3f6f9;\r\n}\r\n\r\n.table-dark {\r\n  --bs-table-bg: #d1d3e0;\r\n  --bs-table-striped-bg: #d1d3e0;\r\n  --bs-table-striped-color: #fff;\r\n  --bs-table-active-bg: #d1d3e0;\r\n  --bs-table-active-color: #fff;\r\n  --bs-table-hover-bg: #d1d3e0;\r\n  --bs-table-hover-color: #fff;\r\n  color: #5b5b5b;\r\n  border-color: #d1d3e0;\r\n}\r\n\r\n.table-dark th {\r\n  background-color: #d1d3e0;\r\n}\r\n\r\n.table-light th {\r\n  background-color: #f3f6f9;\r\n}\r\n\r\n.table * {\r\n  border-color: #262635 !important;\r\n}\r\n\r\n.table td,\r\n.table th {\r\n  padding: 15px 20px !important;\r\n  font-weight: 400;\r\n  vertical-align: middle;\r\n}\r\n\r\n.table tbody tr:last-child td,\r\n.table tbody tr:last-child th {\r\n  border-bottom: none;\r\n}\r\n\r\n.table tfoot tr td,\r\n.table tfoot tr th {\r\n  border-bottom: none;\r\n  border-top-width: 1px;\r\n}\r\n\r\n.table-hover > tbody > tr {\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.table-hover > tbody > tr:hover {\r\n  --bs-table-hover-bg: transparent;\r\n  background: #1f1f2b;\r\n  color: #9a9cab;\r\n}\r\n\r\n.table-striped > tbody > tr:nth-of-type(odd) {\r\n  --bs-table-striped-bg: #181821;\r\n}\r\n\r\n.table-striped > tbody > tr:nth-of-type(odd) {\r\n  color: #9a9cab;\r\n}\r\n\r\n.blockUI.blockOverlay {\r\n  border-radius: inherit;\r\n  background: rgba(24, 24, 33) !important;\r\n  opacity: 0.8 !important;\r\n}\r\n\r\n.blockUI.blockMsg {\r\n  background: 0 0 !important;\r\n  width: 25px !important;\r\n  border: 0 !important;\r\n  height: 25px !important;\r\n  left: calc(50% - 12.5px) !important;\r\n  top: calc(50% - 12.5px) !important;\r\n}\r\n\r\ntable.dataTable {\r\n  margin-top: 20px !important;\r\n  margin-bottom: 20px !important;\r\n}\r\n\r\ntable.dataTable td,\r\ntable.dataTable th {\r\n  padding: 15px 25px !important;\r\n  border-bottom: 1px solid #262635 !important;\r\n}\r\n\r\ntable.dataTable tfoot th {\r\n  border-bottom: 0 !important;\r\n}\r\n\r\ntable.dataTable tfoot th,\r\ntable.dataTable thead th {\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  font-family: Montserrat, sans-serif;\r\n  font-size: 12px;\r\n  color: #9a9cab;\r\n}\r\n\r\ntable.dataTable thead .sorting:before,\r\ntable.dataTable thead .sorting_asc:before,\r\ntable.dataTable thead .sorting_asc_disabled:before,\r\ntable.dataTable thead .sorting_desc:before,\r\ntable.dataTable thead .sorting_desc_disabled:before {\r\n  content: \"\\f077\";\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-size: 14px;\r\n  right: 10px;\r\n  bottom: calc(50% - 4px);\r\n}\r\n\r\ntable.dataTable thead .sorting:after,\r\ntable.dataTable thead .sorting_asc:after,\r\ntable.dataTable thead .sorting_asc_disabled:after,\r\ntable.dataTable thead .sorting_desc:after,\r\ntable.dataTable thead .sorting_desc_disabled:after {\r\n  content: \"\\f078\";\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-size: 14px;\r\n  right: 10px;\r\n  bottom: calc(50% - 14px);\r\n}\r\n\r\ndiv.dataTables_wrapper div.dataTables_length select {\r\n  margin: 0 10px;\r\n}\r\n\r\ndiv.dataTables_wrapper div.dataTables_filter input {\r\n  margin-left: 10px;\r\n}\r\n\r\ntr.group {\r\n  background-color: #181821 !important;\r\n}\r\n\r\n.select2 input {\r\n  color: #fff;\r\n}\r\n\r\n.select2-selection {\r\n  height: auto !important;\r\n  padding: 10px;\r\n  border-radius: 3px !important;\r\n  box-shadow: none;\r\n  border: 1px solid #2d2d3f !important;\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple,\r\n.select2-container--default .select2-selection--single {\r\n  background-color: #181821;\r\n}\r\n\r\n.select2-selection .select2-selection__rendered {\r\n  line-height: 1.5 !important;\r\n  padding-left: 0 !important;\r\n  font-size: 13px;\r\n  color: #9a9cab !important;\r\n}\r\n\r\n.select2-selection .select2-selection__arrow {\r\n  height: 41px !important;\r\n  right: 20px !important;\r\n}\r\n\r\n.select2-selection.select2-selection--multiple {\r\n  padding: 7px 1rem !important;\r\n  min-height: 0 !important;\r\n}\r\n\r\n.select2-selection.select2-selection--multiple .select2-selection__rendered {\r\n  margin-top: 3px;\r\n  margin-bottom: -3px;\r\n}\r\n\r\n.select2-selection.select2-selection--multiple\r\n  .select2-selection__rendered\r\n  input {\r\n  margin-top: 0 !important;\r\n}\r\n\r\n.select2-search--dropdown .select2-search__field {\r\n  padding: 0.65rem 1rem;\r\n  height: auto;\r\n  border-radius: 3px;\r\n  border: 1px solid #37374d;\r\n  font-size: 13px;\r\n  color: #fff;\r\n  background-color: #1f1f2b;\r\n}\r\n\r\n.select2-search--dropdown .select2-search__field:active,\r\n.select2-search--dropdown .select2-search__field:focus {\r\n  box-shadow: none !important;\r\n  border-color: #37374d !important;\r\n  outline: 0;\r\n}\r\n\r\n.select2-dropdown {\r\n  background-color: #1f1f2b;\r\n  padding: 12px 25px !important;\r\n  border: none;\r\n  margin-top: 3px !important;\r\n  border-radius: 3px !important;\r\n  box-shadow: 0 0 1.25rem rgba(31, 45, 61, 0.04);\r\n}\r\n\r\n.select2-dropdown--above {\r\n  margin-top: -3px !important;\r\n  border-bottom: 1px solid #2d2d3f !important;\r\n}\r\n\r\n.select2-selection__choice {\r\n  margin-top: 0 !important;\r\n  height: 19px !important;\r\n  border: 0 !important;\r\n  background: #1f1f2b !important;\r\n  color: #5fd0a5 !important;\r\n  font-size: 12px !important;\r\n  font-weight: 500 !important;\r\n  padding: 0 10px;\r\n}\r\n\r\n.select2-results__option {\r\n  border-radius: 20px;\r\n  padding: 0.65rem 1rem;\r\n}\r\n\r\n.select2-selection__choice span {\r\n  color: #9a9cab !important;\r\n}\r\n\r\n.select2-container--default .select2-results__option .select2-results__option {\r\n  border-radius: 20px;\r\n  margin: 2px 0;\r\n  padding: 0.65rem 1rem;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.select2-container--default\r\n  .select2-results__option--highlighted[aria-selected] {\r\n  background: #1f1f2b;\r\n  color: #83d8ae;\r\n}\r\n\r\n.select2-container--default\r\n  .select2-results__option[aria-selected=\"true\"]:hover {\r\n  color: #fff;\r\n}\r\n\r\n.select2-container--default .select2-results__group {\r\n  padding: 6px;\r\n  font-size: 11px;\r\n  text-transform: uppercase;\r\n  font-family: Montserrat, sans-serif;\r\n  font-weight: 700;\r\n  opacity: 0.7;\r\n}\r\n\r\n.select2-container--default .select2-results__option[aria-selected=\"true\"] {\r\n  color: #fff;\r\n  border: none;\r\n  background: #1f1f2b;\r\n}\r\n\r\n.error-page .container,\r\n.error-page .error-container {\r\n  height: 100%;\r\n  position: relative;\r\n}\r\n\r\n.error-info {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.error-info h1 {\r\n  font-size: 148px;\r\n  color: #83d8ae;\r\n}\r\n\r\n.error-info p {\r\n  font-size: 14px;\r\n}\r\n\r\n.error-image {\r\n  position: absolute;\r\n  right: 0;\r\n  height: 100%;\r\n  width: 50%;\r\n  background: url(../images/500.svg) center center no-repeat;\r\n  background-size: contain;\r\n}\r\n\r\nbody.err-500 .error-image {\r\n  background: url(../images/500.svg) center center no-repeat;\r\n  background-size: contain;\r\n}\r\n\r\nbody.error-page .container {\r\n  max-width: 1140px;\r\n}\r\n\r\n.invoice-details {\r\n  margin-top: 20px;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.invoice-details p {\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.invoice-details p.info {\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  color: #9a9cab;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.invoice-info p {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.invoice-info p span {\r\n  float: right;\r\n}\r\n\r\n.invoice-table th {\r\n  font-weight: 500;\r\n}\r\n\r\n.invoice-table img {\r\n  width: 35px;\r\n  height: 35px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.invoice-table a {\r\n  color: #5b5b5b;\r\n  margin-right: 5px;\r\n}\r\n\r\n.invoice-table svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.invoice-last {\r\n  margin-top: 40px;\r\n}\r\n\r\n.login-page .container,\r\n.login-page .container .row {\r\n  height: 100vh;\r\n}\r\n\r\n.login-page .container .row .login-box-container {\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.authent-logo {\r\n  text-align: center;\r\n}\r\n\r\n.authent-logo img {\r\n  border-radius: 3px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.authent-logo a {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n}\r\n\r\n.authent-text {\r\n  text-align: center;\r\n  margin: 10px 0 15px 0;\r\n  font-size: 16px;\r\n}\r\n\r\n.authent-text p {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.authent-reg {\r\n  text-align: center;\r\n  margin-top: 20px;\r\n}\r\n\r\n.authent-reg p {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.authent-login {\r\n  margin-top: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.authent-login p {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.st-pricing-table {\r\n  text-align: center;\r\n}\r\n\r\n.st-pricing-table li {\r\n  padding: 20px;\r\n}\r\n\r\n.st-pricing-table-header {\r\n  color: #fff;\r\n}\r\n\r\n.email-page .main-wrapper {\r\n  padding-bottom: 0;\r\n}\r\n\r\n.email-page .main-wrapper > .row > div > .card {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.email-list {\r\n  max-height: calc(100vh - 180px);\r\n  overflow-y: auto;\r\n}\r\n\r\n.email-list ul {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.email-list-item {\r\n  color: #9a9cab;\r\n}\r\n\r\n.email-list-item .email-author img {\r\n  width: 35px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.email-list-item .email-author span.author-name {\r\n  margin-left: 7px;\r\n  line-height: 25px;\r\n  color: #fff;\r\n}\r\n\r\n.email-list-item .email-author span.email-date {\r\n  float: right;\r\n  opacity: 0.6;\r\n  line-height: 25px;\r\n  font-size: 12px;\r\n}\r\n\r\n.email-list-item .email-info {\r\n  display: block;\r\n  margin-top: 8px;\r\n}\r\n\r\n.email-list-item .email-info .email-subject {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  display: block;\r\n}\r\n\r\n.email-list-item .email-info .email-text {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  display: block;\r\n  opacity: 0.6;\r\n}\r\n\r\n.email-list li a:active,\r\n.email-list li a:focus,\r\n.email-menu li a:active,\r\n.email-menu li a:focus {\r\n  color: #5b5b5b;\r\n}\r\n\r\n.email-list li a {\r\n  border-radius: 5px;\r\n  display: block;\r\n  padding: 18px 12px;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.email-list li:last-child a {\r\n  border-color: transparent;\r\n}\r\n\r\n.email-list li a:hover {\r\n  background: #1f1f2b;\r\n}\r\n\r\n.email-list li.active a {\r\n  margin-bottom: 5px;\r\n  background: #1f1f2b;\r\n}\r\n\r\n.open-email-content {\r\n  max-height: calc(100vh - 180px);\r\n  overflow-y: auto;\r\n}\r\n\r\n.mail-header {\r\n  width: 100%;\r\n  display: block;\r\n  overflow: hidden;\r\n}\r\n\r\n.mail-title {\r\n  float: left;\r\n  line-height: 20px;\r\n  padding: 4px 0;\r\n  max-width: calc(100% - 285px);\r\n  color: #fff;\r\n}\r\n\r\n.mail-actions {\r\n  float: right;\r\n}\r\n\r\n.mail-info {\r\n  display: block;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  padding-top: 20px;\r\n  padding-bottom: 30px;\r\n  border-bottom: 1px solid #262635;\r\n}\r\n\r\n.mail-info .mail-author {\r\n  float: left;\r\n}\r\n\r\n.mail-info .mail-author img {\r\n  width: 50px;\r\n  border-radius: 5px;\r\n  float: left;\r\n}\r\n\r\n.mail-info .mail-author-info {\r\n  padding: 0 10px;\r\n  display: inline-block;\r\n  height: 50px;\r\n}\r\n\r\n.mail-info .mail-author span.mail-author-name {\r\n  display: block;\r\n  line-height: 25px;\r\n}\r\n\r\n.mail-info .mail-author span.mail-author-address {\r\n  display: block;\r\n  line-height: 25px;\r\n  opacity: 0.6;\r\n}\r\n\r\n.mail-info .mail-other-info {\r\n  float: right;\r\n}\r\n\r\n.mail-info .mail-other-info span {\r\n  line-height: 50px;\r\n}\r\n\r\n.mail-text {\r\n  margin-top: 30px;\r\n}\r\n\r\n.mail-attachment {\r\n  margin-top: 30px;\r\n}\r\n\r\n.mail-attachment-files {\r\n  margin-top: 30px;\r\n}\r\n\r\n.mail-attachment-files .card {\r\n  width: 200px;\r\n  float: left;\r\n  margin-right: 20px;\r\n}\r\n\r\n.mail-attachment-files .card .card-body {\r\n  padding: 15px;\r\n  font-size: 14px;\r\n}\r\n\r\n.mail-attachment-files .card .card-title {\r\n  margin-bottom: 10px;\r\n  font-size: 14px;\r\n}\r\n\r\n.card-subtitle {\r\n  color: #fff;\r\n}\r\n\r\n.file-manager-menu ul li {\r\n  padding: 10px;\r\n}\r\n\r\n.file-manager-menu ul li {\r\n  -webkit-transition: all 0.1s ease-in-out;\r\n  -moz-transition: all 0.1s ease-in-out;\r\n  -o-transition: all 0.1s ease-in-out;\r\n  transition: all 0.1s ease-in-out;\r\n}\r\n\r\n.file-manager-menu ul li a:hover {\r\n  margin-left: 5px;\r\n}\r\n\r\n.file-manager-menu ul li a {\r\n  color: #9a9cab;\r\n  -webkit-transition: all 0.1s ease-in-out;\r\n  -moz-transition: all 0.1s ease-in-out;\r\n  -o-transition: all 0.1s ease-in-out;\r\n  transition: all 0.1s ease-in-out;\r\n}\r\n\r\n.file-manager-menu ul li a i {\r\n  padding-right: 10px;\r\n}\r\n\r\n.file-manager-menu.label-menu ul li a i {\r\n  width: 6px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  background: #000;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin: 0 16px 0 6px;\r\n}\r\n\r\n.file-manager-header {\r\n  color: #fff;\r\n}\r\n\r\n.fmm-title {\r\n  padding: 10px;\r\n  display: block;\r\n  color: #fff;\r\n}\r\n\r\n.file-manager-menu .progress {\r\n  margin-top: 10px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.storage-info-text {\r\n  padding: 10px;\r\n}\r\n\r\n.card-file-manager .card-text {\r\n  opacity: 0.7;\r\n}\r\n\r\n.card-file-header {\r\n  border-top-left-radius: 5px;\r\n  border-top-right-radius: 5px;\r\n  vertical-align: middle;\r\n  font-size: 40px;\r\n  text-align: center;\r\n  line-height: 130px;\r\n  background: #1f1f2b;\r\n}\r\n\r\n.folder .folder-icon {\r\n  float: left;\r\n}\r\n\r\n.folder .folder-icon i {\r\n  font-size: 43px;\r\n  color: #9a9cab;\r\n}\r\n\r\n.folder .folder-info {\r\n  display: block;\r\n  margin-left: 20px;\r\n  float: left;\r\n}\r\n\r\n.folder .folder-info a {\r\n  margin-bottom: 0;\r\n  display: block;\r\n  color: #9a9cab;\r\n}\r\n\r\n.profile-cover {\r\n  width: 100%;\r\n  display: block;\r\n  position: relative;\r\n  border-radius: 15px;\r\n  z-index: 1;\r\n  height: 250px;\r\n  /* height: 350px; */\r\n  background: url(\"../images/profile-back.jpeg\") center center no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\n.profile-cover:after {\r\n  display: block;\r\n  content: \" \";\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  border-radius: 15px;\r\n  background: linear-gradient(rgba(0, 0, 0, 0.3), #000);\r\n}\r\n\r\n.profile-header {\r\n  display: block;\r\n  width: 100%;\r\n  margin-top: -110px;\r\n  padding: 0 30px;\r\n  overflow: hidden;\r\n  z-index: 2;\r\n  position: relative;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.profile-header .profile-img img {\r\n  width: 150px;\r\n  height: 150px;\r\n  border-radius: 150px;\r\n}\r\n\r\n.profile-header .profile-img {\r\n  float: left;\r\n}\r\n\r\n.profile-header .profile-name {\r\n  float: left;\r\n  margin-top: 50px;\r\n  margin-left: 30px;\r\n}\r\n\r\n.profile-header .profile-name h3 {\r\n  color: #fff;\r\n  font-weight: 400;\r\n  font-size: 22px;\r\n  line-height: 50px;\r\n}\r\n\r\n.profile-header .profile-header-menu {\r\n  float: right;\r\n  height: 100%;\r\n  margin-top: 39px;\r\n}\r\n\r\n.profile-header .profile-header-menu ul li {\r\n  float: left;\r\n  height: 100%;\r\n  padding: 25px;\r\n}\r\n\r\n.profile-header .profile-header-menu ul li a {\r\n  color: #7d7d83;\r\n  display: block;\r\n  font-weight: 400;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.profile-header .profile-header-menu ul li a.active,\r\n.profile-header .profile-header-menu ul li a:hover {\r\n  color: #fff;\r\n}\r\n\r\nul.profile-about-list {\r\n  margin-bottom: 0;\r\n}\r\n\r\nul.profile-about-list li {\r\n  margin-bottom: 10px;\r\n}\r\n\r\nul.profile-about-list li.profile-about-list-buttons {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.story-list .story {\r\n  overflow: hidden;\r\n  display: block;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.story-list .story:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.story-list .story img {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50px;\r\n  border: 2px solid #86c1ed;\r\n  padding: 2px;\r\n  float: left;\r\n}\r\n\r\n.story-list .story .story-info {\r\n  float: left;\r\n  padding: 5px 15px;\r\n}\r\n\r\n.story-list .story .story-info span.story-author {\r\n  display: block;\r\n  line-height: 20px;\r\n  color: #9a9cab;\r\n}\r\n\r\n.story-list .story .story-info span.story-time {\r\n  line-height: 20px;\r\n  font-size: 13px;\r\n  opacity: 0.6;\r\n}\r\n\r\n.post-body,\r\n.post-header {\r\n  display: block;\r\n  overflow: hidden;\r\n  width: 100%;\r\n}\r\n\r\n.post-header img {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 5px;\r\n  float: left;\r\n}\r\n\r\n.post-header .post-info {\r\n  float: left;\r\n  padding: 4px 15px 0 15px;\r\n}\r\n\r\n.post-header .post-info span.post-date {\r\n  font-size: 13px;\r\n  opacity: 0.6;\r\n}\r\n\r\n.post-header .post-header-actions {\r\n  float: right;\r\n  padding: 15px 0;\r\n}\r\n\r\n.post-header .post-header-actions a {\r\n  line-height: 20px;\r\n  color: #646464;\r\n}\r\n\r\n.post-header .post-header-actions a:hover {\r\n  color: #333;\r\n}\r\n\r\n.post-body {\r\n  padding: 15px 0 0 0;\r\n  position: relative;\r\n}\r\n\r\n.post-body p {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.post-header .post-info span.post-author {\r\n  font-size: 15px;\r\n}\r\n\r\n.post-body .post-image {\r\n  display: block;\r\n  width: 100%;\r\n  border-radius: 6px;\r\n  margin-top: 15px;\r\n  max-height: 500px;\r\n  object-fit: contain;\r\n}\r\n\r\n.post-actions,\r\n.post-actions ul {\r\n  display: block;\r\n  overflow: hidden;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.post-actions {\r\n  margin-top: 15px;\r\n  padding: 5px 10px 0;\r\n}\r\n\r\n.post-actions ul li a {\r\n  float: left;\r\n  padding: 5px 8px;\r\n  font-size: 15px;\r\n  color: #9a9cab;\r\n  margin-right: 10px;\r\n}\r\n\r\n.post-actions ul li a:hover {\r\n  color: #83d8ae;\r\n}\r\n\r\n.post-actions ul li a.liked {\r\n  color: #844ff1;\r\n}\r\n\r\n.post-actions ul li a.liked i:before {\r\n  content: \"\\f004\";\r\n}\r\n\r\n.post-actions ul li a i {\r\n  margin-right: 7px;\r\n}\r\n\r\n.post-comments {\r\n  margin-top: 5px;\r\n  padding-top: 15px;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.post-comments .post-comm {\r\n  display: block;\r\n  margin-bottom: 10px;\r\n  border-radius: 5px;\r\n  padding: 15px;\r\n  overflow: hidden;\r\n}\r\n\r\n.post-comments .post-comm:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.post-comments .post-comm img {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 5px;\r\n  float: left;\r\n}\r\n\r\n.post-comments .post-comm .comment-container {\r\n  float: left;\r\n  padding: 0 10px;\r\n  width: calc(100% - 30px);\r\n  display: block;\r\n}\r\n\r\n.post-comments .post-comm .comment-container span.comment-author {\r\n  color: #fff;\r\n  display: block;\r\n  line-height: 30px;\r\n}\r\n\r\n.post-comments .post-comm .comment-container span.comment-author small {\r\n  float: right;\r\n  font-size: 13px;\r\n  color: #9a9cab;\r\n  /* opacity: 0.6; */\r\n}\r\n\r\n.post-comments .post-comm .comment-text {\r\n  padding: 10px 0 0 0;\r\n  display: inline-block;\r\n  margin-left: 40px;\r\n}\r\n\r\n.fc-toolbar h2 {\r\n  font-size: 20px !important;\r\n  font-weight: 400;\r\n  color: #fff;\r\n}\r\n\r\n.fc-next-button.fc-button.fc-button-primary,\r\n.fc-next-button.fc-button.fc-button-primary.active,\r\n.fc-next-button.fc-button.fc-button-primary:focus,\r\n.fc-prev-button.fc-button.fc-button-primary,\r\n.fc-prev-button.fc-button.fc-button-primary.active,\r\n.fc-prev-button.fc-button.fc-button-primary:focus {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n  color: #fff;\r\n  border-radius: 3px;\r\n  padding: 8px 5px;\r\n}\r\n\r\n.fc-next-button.fc-button.fc-button-primary:hover,\r\n.fc-prev-button.fc-button.fc-button-primary:hover {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n  color: #fff;\r\n  box-shadow: 0 3px 18px -8px #83d8ae;\r\n}\r\n\r\n.fc-today-button.fc-button.fc-button-primary,\r\n.fc-today-button.fc-button.fc-button-primary.active,\r\n.fc-today-button.fc-button.fc-button-primary:focus {\r\n  background-color: #e9f0f2;\r\n  border-color: #e9f0f2;\r\n  color: #355261;\r\n  border-radius: 3px;\r\n  padding: 8px 20px;\r\n}\r\n\r\n.fc .fc-button-primary:disabled {\r\n  background-color: #e9f0f2;\r\n  border-color: #e9f0f2;\r\n  color: #355261;\r\n}\r\n\r\n#calendar a {\r\n  color: #9a9cab;\r\n}\r\n\r\n.fc-col-header-cell-cushion {\r\n  font-weight: 400;\r\n}\r\n\r\n.fc .fc-daygrid-day.fc-day-today {\r\n  background-color: #d8f2e5;\r\n}\r\n\r\n.fc-scrollgrid-section.fc-scrollgrid-section-header {\r\n  border: none;\r\n}\r\n\r\n.fc-h-event {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n  color: #fff;\r\n  padding: 3px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.fc-event-title.fc-sticky {\r\n  padding: 2px 10px;\r\n  color: #fff;\r\n  font-weight: 500;\r\n}\r\n\r\n.fc-daygrid-event {\r\n  border-radius: 15px;\r\n}\r\n\r\n.fc-daygrid-event:hover {\r\n  background-color: #83d8ae;\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.fc-daygrid-dot-event .fc-event-title {\r\n  font-weight: 400;\r\n}\r\n\r\n.fc-daygrid-event-dot {\r\n  border-color: #83d8ae;\r\n}\r\n\r\n.fc table,\r\n.fc-theme-standard td,\r\n.fc-theme-standard th {\r\n  border-color: #262635 !important;\r\n}\r\n\r\n.card.stats-card {\r\n  padding: 6px 0;\r\n}\r\n\r\n.stats-card .stats-info {\r\n  float: left;\r\n}\r\n\r\n.stats-card .card-title {\r\n  font-size: 20px;\r\n  line-height: 32px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.stats-card .card-title span.stats-change {\r\n  font-size: 14px;\r\n  vertical-align: text-top;\r\n  margin-left: 10px;\r\n}\r\n\r\n.stats-card .card-title span.stats-change.stats-change-success {\r\n  color: #83d8ae;\r\n}\r\n\r\n.stats-card .card-title span.stats-change.stats-change-danger {\r\n  color: #e8538f;\r\n}\r\n\r\n.stats-card .stats-text {\r\n  margin-bottom: 0;\r\n  line-height: 25px;\r\n  margin-top: 10px;\r\n  font-size: 13px;\r\n  color: #9a9cab;\r\n}\r\n\r\n.stats-card .stats-icon {\r\n  float: right;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  line-height: 1;\r\n  margin: 11px 15px 0 0;\r\n}\r\n\r\n.stats-card .stats-icon.change-success {\r\n  color: #fff;\r\n  background-color: #83d8ae;\r\n  box-shadow: 0 3px 18px -8px #83d8ae;\r\n}\r\n\r\n.stats-card .stats-icon.change-danger {\r\n  color: #fff;\r\n  background: #e8538f;\r\n  box-shadow: 0 3px 18px -8px #e8538f;\r\n}\r\n\r\n.stats-card .stats-icon i {\r\n  line-height: 1;\r\n}\r\n\r\n.widget-info .widget-info-container {\r\n  text-align: center;\r\n}\r\n\r\n.widget-info .widget-info-container .widget-info-image {\r\n  width: 100%;\r\n  height: 158px;\r\n  background-size: 191px !important;\r\n  background-position: center center !important;\r\n  background-repeat: no-repeat !important;\r\n}\r\n\r\n.widget-info .widget-info-container .widget-info-title {\r\n  margin: 21px 0;\r\n}\r\n\r\n.widget-info .widget-info-container .widget-info-text {\r\n  text-align: center;\r\n  color: #9a9cab;\r\n}\r\n\r\n.widget-info .widget-info-container .widget-info-action {\r\n  margin: 14px 0 10px;\r\n  display: inline-block;\r\n}\r\n\r\n.transactions-list {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.transactions-list:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.tr-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.tr-item .tr-text h4 {\r\n  font-size: 14px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.tr-item .tr-text p {\r\n  font-size: 12px;\r\n  margin-bottom: 0;\r\n  color: #9a9cab;\r\n}\r\n\r\n.tr-company-name {\r\n  display: flex;\r\n}\r\n\r\n.tr-rate {\r\n  align-self: center;\r\n}\r\n\r\n.tr-rate p {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.tr-icon {\r\n  margin-right: 16px;\r\n}\r\n\r\n.tr-card-icon {\r\n  border-radius: 5px;\r\n  width: 44px;\r\n  height: 44px;\r\n  padding: 9px 13px;\r\n}\r\n\r\n.tr-card-icon svg {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.tr-text {\r\n  align-self: center;\r\n}\r\n\r\n.tr-text a {\r\n  color: #5b5b5b;\r\n}\r\n\r\n.tr-img {\r\n  margin-right: 16px;\r\n}\r\n\r\n.tr-img img {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.tr-card-bg-primary {\r\n  background-color: #86c1ed !important;\r\n  box-shadow: 0 3px 18px -8px #86c1ed;\r\n}\r\n\r\n.tr-card-bg-secondary {\r\n  background-color: #e9f0f2 !important;\r\n  box-shadow: 0 3px 18px -8px #e9f0f2;\r\n}\r\n\r\n.tr-card-bg-success {\r\n  background-color: #83d8ae !important;\r\n  box-shadow: 0 3px 18px -8px #83d8ae;\r\n}\r\n\r\n.tr-card-bg-danger {\r\n  background-color: #e8538f !important;\r\n  box-shadow: 0 3px 18px -8px #e8538f;\r\n}\r\n\r\n.tr-card-bg-warning {\r\n  background-color: #fad292 !important;\r\n  box-shadow: 0 3px 18px -8px #fad292;\r\n}\r\n\r\n.tr-card-bg-info {\r\n  background-color: #ada6f2 !important;\r\n  box-shadow: 0 3px 18px -8px #ada6f2;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .actions-widget .card-body {\r\n    display: flex;\r\n  }\r\n\r\n  .actions-widget .actions-widget-item {\r\n    flex: 1;\r\n  }\r\n\r\n  .actions-widget .actions-widget-item .actions-widget-item-title {\r\n    margin-bottom: 0 !important;\r\n  }\r\n}\r\n\r\n.actions-widget .actions-widget-item .actions-widget-item-title {\r\n  margin: 14px 0;\r\n  display: block;\r\n}\r\n\r\n.actions-widget .btn {\r\n  width: 70px;\r\n  height: 70px;\r\n  margin: 0 20px;\r\n  border: 1px solid #2d2d40;\r\n  background-color: #262635;\r\n}\r\n\r\n.actions-widget .btn:hover {\r\n  box-shadow: 0 3px 18px -8px #2d2d40;\r\n}\r\n\r\n.actions-widget .btn i {\r\n  font-size: 20px;\r\n}\r\n\r\n.crypto-table img {\r\n  width: 30px;\r\n  margin: 5.3px 10px 5.2px 0;\r\n}\r\n\r\n.contact-card img {\r\n  width: 80px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.contact-card-info {\r\n  margin-top: 30px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.contact-card-info h6 {\r\n  color: #fff;\r\n  font-size: 15px;\r\n}\r\n\r\n.contact-card-buttons .btn {\r\n  margin: 0 3px;\r\n}\r\n\r\n#sparkline1,\r\n#sparkline2,\r\n#sparkline3,\r\n#sparkline4,\r\n#sparkline5,\r\n#sparkline6 {\r\n  text-align: center;\r\n}\r\n\r\n.jqstooltip {\r\n  box-sizing: content-box;\r\n}\r\n\r\n.loader {\r\n  position: fixed;\r\n  height: 100%;\r\n  width: 100%;\r\n  background: #fff;\r\n  z-index: 11000;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.loader .spinner-grow {\r\n  top: 50%;\r\n  left: 50%;\r\n  margin: -20px 0 0 -20px;\r\n  position: absolute;\r\n  width: 40px;\r\n  height: 40px;\r\n  color: #86c1ed;\r\n}\r\n\r\n.no-loader .loader {\r\n  visibility: hidden;\r\n  opacity: 0;\r\n}\r\n\r\n.pace .pace-progress {\r\n  z-index: 999999;\r\n}\r\n\r\n.activity-sidebar {\r\n  z-index: 10001;\r\n  width: 700px;\r\n  background-color: #181821;\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  height: 100%;\r\n  transform: translateX(700px);\r\n  overflow: auto;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n  padding: 20px 30px 0 30px;\r\n}\r\n\r\n.activity-sidebar-show .activity-sidebar {\r\n  transform: translateX(0);\r\n}\r\n\r\n.activity-sidebar-overlay {\r\n  position: fixed;\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 10000;\r\n  background-color: rgba(0, 0, 0, 0.8);\r\n  display: block;\r\n}\r\n\r\n.activity-sidebar-show .activity-sidebar-overlay {\r\n  visibility: visible;\r\n  opacity: 0.4;\r\n}\r\n\r\n#activity-sidebar-close {\r\n  position: absolute;\r\n  right: 30px;\r\n  cursor: pointer;\r\n}\r\n\r\n.activity-header {\r\n  margin-bottom: 30px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.activity-header h5 {\r\n  color: #fff;\r\n}\r\n\r\n#activity-sidebar-close i {\r\n  padding: 7px 0;\r\n  color: #9a9cab;\r\n}\r\n\r\n.activity-list .activity-item {\r\n  padding: 20px;\r\n  border-radius: 5px;\r\n  overflow: hidden;\r\n  margin-bottom: 10px;\r\n  border: 1px solid #262635;\r\n}\r\n\r\n.activity-list .activity-item .activity-icon {\r\n  float: left;\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n  height: 40px;\r\n  width: 40px;\r\n  text-align: center;\r\n  line-height: 30px;\r\n  margin-right: 15px;\r\n  background: #83d8ae;\r\n  color: #fff;\r\n  box-shadow: 0 3px 18px -8px #83d8ae;\r\n}\r\n\r\n.activity-list .activity-item.activity-primary .activity-icon {\r\n  background: #86c1ed;\r\n  color: #fff;\r\n  box-shadow: 0 3px 18px -8px #86c1ed;\r\n}\r\n\r\n.activity-list .activity-item.activity-secondary .activity-icon {\r\n  background: #e9f0f2;\r\n  color: #5b6875;\r\n  box-shadow: 0 3px 18px -8px #e9f0f2;\r\n}\r\n\r\n.activity-list .activity-item.activity-danger .activity-icon {\r\n  background: #e8538f;\r\n  color: #fff;\r\n  box-shadow: 0 3px 18px -8px #e8538f;\r\n}\r\n\r\n.activity-list .activity-item.activity-warning .activity-icon {\r\n  background: #fad292;\r\n  color: #fff;\r\n  box-shadow: 0 3px 18px -8px #fad292;\r\n}\r\n\r\n.activity-list .activity-item.activity-info .activity-icon {\r\n  background: #ada6f2;\r\n  color: #fff;\r\n  box-shadow: 0 3px 18px -8px #ada6f2;\r\n}\r\n\r\n.activity-list .activity-item .activity-icon i {\r\n  line-height: 30px;\r\n}\r\n\r\n.activity-list .activity-item .activity-text {\r\n  float: left;\r\n  line-height: 20px;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  margin-top: 1px;\r\n}\r\n\r\n.activity-list .activity-item .activity-text span {\r\n  clear: both;\r\n  display: block;\r\n  font-size: 13px;\r\n  color: #9a9cab;\r\n  padding-top: 2px;\r\n}\r\n\r\n.activity-list .activity-item .activity-helper {\r\n  float: right;\r\n  line-height: 50px;\r\n  color: #9a9cab;\r\n  font-size: 13px;\r\n}\r\n\r\n.search-results {\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  position: fixed;\r\n  top: 90px;\r\n  bottom: 0;\r\n  left: 220px;\r\n  right: 30px;\r\n  z-index: 999;\r\n  background: #181821;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n  overflow-y: auto;\r\n}\r\n\r\n.page-sidebar-collapsed .search-results {\r\n  left: 100px;\r\n}\r\n\r\n.search-results .search-results-header {\r\n  padding: 40px 19.5px 10px 49.5px;\r\n  overflow: hidden;\r\n  display: block;\r\n  margin-bottom: 50px;\r\n  color: #fff;\r\n}\r\n\r\n.search-results .search-results-header h5 {\r\n  float: left;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.search-results .search-results-header a#closeSearch {\r\n  float: right;\r\n  vertical-align: middle;\r\n  color: #fff;\r\n  opacity: 0.7;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.search-results .search-results-header a#closeSearch:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.search-results-show {\r\n  overflow-y: hidden;\r\n}\r\n\r\n.search-results-show .search-results {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.search-result-list {\r\n  list-style-type: none;\r\n  padding: 0 49.5px;\r\n}\r\n\r\n.search-result-list li {\r\n  display: block;\r\n  clear: both;\r\n  margin-bottom: 40px;\r\n  overflow: hidden;\r\n}\r\n\r\n.search-result-list.user-search li img {\r\n  width: 50px;\r\n  border-radius: 5px;\r\n  float: left;\r\n}\r\n\r\n.search-result-list.user-search li p {\r\n  display: block;\r\n  float: left;\r\n  padding: 5px 15px;\r\n  width: calc(100% - 50px);\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.search-result-list span.search-input-value {\r\n  font-weight: 700;\r\n}\r\n\r\n.search-result-list.article-search li p {\r\n  margin-bottom: 5px;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.search-result-list.article-search li span:not(.search-input-value) {\r\n  opacity: 0.4;\r\n}\r\n\r\n.search-result-list.social-search li .social-search-icon {\r\n  display: inline-block;\r\n  margin: 0 10px 0 0;\r\n  width: 50px;\r\n  height: 50px;\r\n  text-align: center;\r\n  line-height: 50px;\r\n  background: #000;\r\n  color: #fff;\r\n  border-radius: 5px;\r\n}\r\n\r\n.search-result-list.social-search li .social-search-icon.facebook-icon-bg {\r\n  background: #3360ff;\r\n}\r\n\r\n.search-result-list.social-search li .social-search-icon.twitter-icon-bg {\r\n  background: #1da1f2;\r\n}\r\n\r\n.search-result-list.social-search li .social-search-icon.google-icon-bg {\r\n  background: #0f9d58;\r\n}\r\n\r\n.search-result-list.social-search li .social-search-text {\r\n  display: inline-block;\r\n  padding: 5px;\r\n}\r\n\r\n.search-result-list.social-search li .social-search-text p {\r\n  line-height: 40px;\r\n}\r\n\r\n.css-13cymwt-control {\r\n  background-color: #1f1f2b !important;\r\n  border-color: #252533 !important;\r\n  color: #fff !important;\r\n  font-size: 15px !important;\r\n}\r\n\r\n.css-1nmdiq5-menu {\r\n  background-color: #1f1f2b !important;\r\n  border-color: #252533 !important;\r\n  color: #fff !important;\r\n  font-size: 15px !important;\r\n}\r\n\r\n.css-1dimb5e-singleValue {\r\n  color: #fff !important;\r\n}\r\n\r\n.css-t3ipsp-control {\r\n  background-color: #1f1f2b !important;\r\n  border-color: #252533 !important;\r\n  color: #fff !important;\r\n  font-size: 15px !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.css-t3ipsp-control:hover {\r\n  background-color: #181821 !important;\r\n  color: #000 !important;\r\n  border-color: #252533 !important;\r\n}\r\n\r\n.css-166bipr-Input {\r\n  color: #fff !important;\r\n  font-size: 15px !important;\r\n}\r\n\r\n.css-1nmdiqs-menu:hover {\r\n  background-color: #fff !important;\r\n  color: #000 !important;\r\n}\r\n\r\n.css-1cfo1cf {\r\n  color: #fff !important;\r\n}\r\n\r\n@media (max-width: 1350px) {\r\n  .page-header .navbar #navbarNav {\r\n    flex: 0;\r\n    margin-right: 15px;\r\n  }\r\n\r\n  .page-header .navbar .logo {\r\n    flex: 0 !important;\r\n  }\r\n\r\n  .page-header .navbar #navbarNav .navbar-nav li a {\r\n    display: none;\r\n  }\r\n\r\n  .page-header .navbar a#sidebar-toggle {\r\n    display: block;\r\n    transform: rotate(-180deg);\r\n  }\r\n\r\n  body.sidebar-hidden .page-header .navbar a#sidebar-toggle {\r\n    transform: rotate(0);\r\n  }\r\n\r\n  body:not(.sidebar-hidden) .page-sidebar {\r\n    transform: scale(0, 1);\r\n    z-index: 999;\r\n  }\r\n\r\n  body.sidebar-hidden .page-sidebar {\r\n    transform: scale(1, 1);\r\n  }\r\n\r\n  .page-header {\r\n    width: calc(100% - 56px);\r\n    padding: 0;\r\n  }\r\n\r\n  .page-content {\r\n    margin-left: 0;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n\r\n  .search-results {\r\n    left: 0;\r\n    right: 0;\r\n  }\r\n\r\n  body.sidebar-hidden .page-content {\r\n    transform: translateX(260px);\r\n  }\r\n\r\n  body.sidebar-hidden .page-content {\r\n    margin-left: 0;\r\n  }\r\n\r\n  body.sidebar-hidden .page-header {\r\n    width: calc(100% - 56px);\r\n  }\r\n\r\n  .page-footer {\r\n    margin: 0 30px;\r\n    width: calc(100% - 60px);\r\n  }\r\n}\r\n\r\n@media (max-width: 700px) {\r\n  .activity-sidebar {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .profile-header {\r\n    margin-top: -60px;\r\n  }\r\n\r\n  .profile-cover {\r\n    height: 200px;\r\n  }\r\n\r\n  .profile-img {\r\n    display: block;\r\n    float: none !important;\r\n  }\r\n\r\n  .profile-img img {\r\n    margin: 0 auto;\r\n    display: inherit;\r\n    width: 100px !important;\r\n    height: 100px !important;\r\n    border-radius: 100px !important;\r\n  }\r\n\r\n  .profile-name {\r\n    display: block;\r\n    float: none !important;\r\n    text-align: center;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .profile-name h3 {\r\n    color: #fff !important;\r\n  }\r\n\r\n  .profile-header .profile-header-menu {\r\n    display: block;\r\n    float: none;\r\n    margin: 0;\r\n    text-align: center;\r\n  }\r\n\r\n  .profile-header .profile-header-menu ul li {\r\n    display: block;\r\n    padding: 0;\r\n    width: calc(100% / 6);\r\n    text-align: center;\r\n  }\r\n\r\n  .profile-header .profile-header-menu ul li a {\r\n    padding: 10px;\r\n    text-align: center;\r\n    height: auto !important;\r\n  }\r\n\r\n  .profile-header .profile-header-menu ul li a.active,\r\n  .profile-header .profile-header-menu ul li a:hover {\r\n    color: #fff;\r\n  }\r\n\r\n  .mail-actions {\r\n    display: none;\r\n  }\r\n\r\n  .mail-title {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .error-image {\r\n    display: none;\r\n  }\r\n\r\n  .error-info {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n\r\n  .header-search {\r\n    width: 100%;\r\n    margin: 0;\r\n    height: 70px;\r\n    display: block !important;\r\n    position: absolute;\r\n    top: 0;\r\n    z-index: 99999;\r\n    left: 0;\r\n    transform: translateY(-100%);\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    -webkit-transition: all 0.2s ease-in-out;\r\n    -moz-transition: all 0.2s ease-in-out;\r\n    -o-transition: all 0.2s ease-in-out;\r\n    transition: all 0.2s ease-in-out;\r\n  }\r\n\r\n  .header-search .close-search {\r\n    display: block;\r\n  }\r\n\r\n  .header-search .form-control {\r\n    height: 70px;\r\n  }\r\n\r\n  .header-search::before {\r\n    height: 70px;\r\n    line-height: 70px;\r\n  }\r\n\r\n  .search-show .header-search {\r\n    transform: none;\r\n    visibility: visible;\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
